<template>
  <div class="home">
	  <div class="ysbj"> 
<div class="card-box">
	<el-card class="box-card" shadow="always" >
	</el-card>
</div>
  <div class="wrapper">   
   	<el-tabs type="card"  v-model="activeName" @tab-click="handleClick" class="tabsCard">
   	  <el-tab-pane name="fcl">
   	    <span slot="label"><i class="iconfont icon-lunchuan"></i> {{$t('m.hyzx')}}</span>
		<div  class="fclstylepc">
			<div class="box-query">
				<span class="wz">{{$t('m.t.cong')}}</span>
				<el-select
				default-first-option
				class="zhselect"
				 v-model="queryInfo.pol" 
				filterable 
				:placeholder="$t('m.t.qxzselect')"
				:filter-method="polFilterMethod"
				:loading="loadingPolSelect"
				>
				
				    <el-option
					  v-if="polquery !== ''"
				      v-for="item in polList"
				      :key="item.pol"
				      :label="`${item.pol}  /  ${item.polcode }`"
				      :value="item.pol">
					
					  <span style="float: left;margin-top:-10px">
					  <i class="iconfont icon-haiguangangkou"></i>
					  {{ item.pol }}
				      </span>
					  <span style="float: left;
					  display:block;
					  position:absolute;
					  margin-top:15px;
					  font-size: 12px;
					  color:gray
					  ">
					  {{$t('m.t.Port')}}
					  {{ item.polzhname }}
					  </span>
					
					  
					  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.polcode }}</span>
				    </el-option>
				
				
				
				<el-option-group
				  v-if="polquery === ''"
				     v-for="group in polList"
				     :key="group.label"
				     :label="group.label">
				     <el-option
				       v-for="item in group.options"
				       :key="item.label"
				       :label="`${item.label}  /  ${item.value }`"
				       :value="item.label">
					   
					   
					   <span style="float: left;margin-top:-10px">
					   <i class="iconfont icon-haiguangangkou"></i>
					   {{ item.label }}
					   </span>
					   <span style="float: left;
					   display:block;
					   position:absolute;
					   margin-top:15px;
					   font-size: 12px;
					   color:gray
					   ">
					   {{$t('m.t.Port')}}
					   {{ item.zhlabel }}
					   </span>
					   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
					   
			
				     </el-option>
				   </el-option-group>
				
				
				
				
				  </el-select>
				 <img src="../../assets/img/right.png" alt="" width="50px" height="40px">
				  <span class="wz">{{$t('m.t.dao')}}</span>
				  <el-select
				  @keyup.enter.native="queryShow"
				  default-first-option
				  @focus="focusfclpod"
				  class="zhselect"
				  v-model="queryInfo.pod" 
				  filterable
				  :placeholder="$t('m.t.qxzselect')"
				  :filter-method="podFilterMethod"
				  :loading="loadingPodSelect"
				  >
				     <el-option
				       v-if="podquery !== ''"
				         v-for="item in podList"
				         :key="item.pod"
				         :label="`${item.pod}  /  ${item.podcode }`"
				         :value="item.pod">
				     	<span style="float: left;margin-top:-10px">
						<i class="iconfont icon-haiguangangkou"></i>{{ item.pod }}
						</span>
						<span style="float: left;
						display:block;
						position:absolute;
						margin-top:15px;
						font-size: 12px;
						color:gray
						">
						{{$t('m.t.Port')}}
						{{ item.podzhname }}
						</span>
						
				     	<span style="float: right; color: #8492a6; font-size: 13px">{{ item.podcode}}</span>
				       </el-option>
				     
				     <el-option-group
				       v-if="podquery == ''"
				          v-for="group in podList"
				          :key="group.label"
				          :label="group.label">
				          <el-option
				            v-for="item in group.options"
				            :key="item.label"
				            :label="`${item.label}  /  ${item.value }`"
				            :value="item.label">
							
							<span style="float: left;margin-top:-10px">
							<i class="iconfont icon-haiguangangkou"></i>
							{{ item.label }}
							</span>
							<span style="float: left;
							display:block;
							position:absolute;
							margin-top:15px;
							font-size: 12px;
							color:gray
							">
							{{$t('m.t.Port')}}
							{{ item.zhlabel }}
							</span>
												
							
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
				     	  
				     	   
				          </el-option>
				        </el-option-group>
				     
				
				    </el-select>

		</div>
	<div style="height:72px;display: flex;margin:6px 0;">
			<el-button 
			type="primary" 
			icon="el-icon-search"  
			style="margin-left:30px;width: 200px;margin: 0 20px;"
			 @click="queryShow"
			@keyup.enter="keyDown(e)"
			 >{{$t('m.t.Search')}}</el-button>
			<span 
			style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
			<img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
			</span>
			</div>
			</div>
			
			<div class="fclstylephone">
				<div class="box-query">
				<span class="wz">{{$t('m.t.cong')}}</span>
				<el-select
				default-first-option
				class="zhselect"
				 v-model="queryInfo.pol" 
				filterable 
				:placeholder="$t('m.t.qxzselect')"
				:filter-method="polFilterMethod"
				:loading="loadingPolSelect"
				>
				
				    <el-option
					  v-if="polquery !== ''"
				      v-for="item in polList"
				      :key="item.pol"
				      :label="`${item.pol}  /  ${item.polcode }`"
				      :value="item.pol">
					
					  <span style="float: left;margin-top:-10px">
					  <i class="iconfont icon-haiguangangkou"></i>
					  {{ item.pol }}
				      </span>
					  <span style="float: left;
					  display:block;
					  position:absolute;
					  margin-top:15px;
					  font-size: 12px;
					  color:gray
					  ">
					  {{$t('m.t.Port')}}
					  {{ item.polzhname }}
					  </span>
					
					  
					  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.polcode }}</span>
				    </el-option>
				
				
				
				<el-option-group
				  v-if="polquery === ''"
				     v-for="group in polList"
				     :key="group.label"
				     :label="group.label">
				     <el-option
				       v-for="item in group.options"
				       :key="item.label"
				       :label="`${item.label}  /  ${item.value }`"
				       :value="item.label">
					   
					   
					   <span style="float: left;margin-top:-10px">
					   <i class="iconfont icon-haiguangangkou"></i>
					   {{ item.label }}
					   </span>
					   <span style="float: left;
					   display:block;
					   position:absolute;
					   margin-top:15px;
					   font-size: 12px;
					   color:gray
					   ">
					   {{$t('m.t.Port')}}
					   {{ item.zhlabel }}
					   </span>
					   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
					   
							
				     </el-option>
				   </el-option-group>
				  </el-select>
				  </div>
				  <span style="margin-left: 30px;">——</span>
				  <div class="box-query"  >
				 <span class="wz">{{$t('m.t.dao')}}</span>
				 <el-select
				 @keyup.enter.native="queryShow"
				 default-first-option
				 @focus="focusfclpod"
				 class="zhselect"
				 v-model="queryInfo.pod" 
				 filterable
				 :placeholder="$t('m.t.qxzselect')"
				 :filter-method="podFilterMethod"
				 :loading="loadingPodSelect"
				 >
				    <el-option
				      v-if="podquery !== ''"
				        v-for="item in podList"
				        :key="item.pod"
				        :label="`${item.pod}  /  ${item.podcode }`"
				        :value="item.pod">
				    	<span style="float: left;margin-top:-10px">
				 						<i class="iconfont icon-haiguangangkou"></i>{{ item.pod }}
				 						</span>
				 						<span style="float: left;
				 						display:block;
				 						position:absolute;
				 						margin-top:15px;
				 						font-size: 12px;
				 						color:gray
				 						">
				 						{{$t('m.t.Port')}}
				 						{{ item.podzhname }}
				 						</span>
				 						
				    	<span style="float: right; color: #8492a6; font-size: 13px">{{ item.podcode}}</span>
				      </el-option>
				    
				    <el-option-group
				      v-if="podquery == ''"
				         v-for="group in podList"
				         :key="group.label"
				         :label="group.label">
				         <el-option
				           v-for="item in group.options"
				           :key="item.label"
				           :label="`${item.label}  /  ${item.value }`"
				           :value="item.label">
				 							
				 							<span style="float: left;margin-top:-10px">
				 							<i class="iconfont icon-haiguangangkou"></i>
				 							{{ item.label }}
				 							</span>
				 							<span style="float: left;
				 							display:block;
				 							position:absolute;
				 							margin-top:15px;
				 							font-size: 12px;
				 							color:gray
				 							">
				 							{{$t('m.t.Port')}}
				 							{{ item.zhlabel }}
				 							</span>
				 												
				 							
				 							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
				    	  
				    	   
				         </el-option>
				       </el-option-group>
				    
				 				
				   </el-select> 
				  </div>
				<el-button
				type="primary" 
				icon="el-icon-search"  
				style="margin-left:30px;width: 200px;margin: 15px 20px;"
				 @click="queryShow"
				@keyup.enter="keyDown(e)"
				 >{{$t('m.t.Search')}}</el-button>
			</div>
			
			
			
			
	<!-- 特价卡片 -->
	<div class="tjcard">
		   <el-card class="boxtjcard" shadow="always">
			   <div slot="header" class="clearfix">
			       <span>{{$t('m.t.jrthhx')}}</span>
			     </div>
				 <!-- 海运整箱 -->
				 <div class="fcltjcardstyle">
				<div v-if="this.specialPriceFclList.length > 0 " style="margin: -15px;" >
				
				
<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
	<el-carousel-item v-for="item in Math.ceil(this.specialPriceFclList.length / 6)" :key="item.id">			
					<div style="display: flex;flex-wrap: wrap;">
					<div 
					:title="$t('m.tjcard.dc')"
					style="padding: 10px;"
					v-for="(item1,index) in specialPriceFclList.slice((item-1) * 6,item*6)"
					:key="item1.id"
					v-if="index<=5"
					@click="fcltj(item1)"
					:class="{'ggg':item1.id==hoverIndex}"
					@mouseover="hoverIndex=item1.id"
					@mouseleave="hoverIndex = -1"
					>
					
					<el-card class="box-card-list" shadow="always" >
					<!-- 	<div style="display: flex;justify-content: space-between;">
						<button type="primary" size="mini">我要订舱</button>
						</div> -->
						<div style="display: flex;justify-content: space-between;">
						<span>{{item1.pol}}</span>
						<i class="iconfont icon-jiantou"></i>
						<span>{{item1.pod}}</span>
						</div>
						<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
						<span>{{`${'$' + item1['20GP'] + ' /'+'$' + item1['40GP']+ ' /' +'$'+ item1['40HQ']}`}}</span>	
						</div>
						<div style="padding-top: 10px;display: flex;justify-content: space-between;">
						<span>{{$t('m.tjcard.cq')}}:{{item1.sale_state}}</span>
					    <span>{{$t('m.tjcard.cgs')}}:{{item1.carrier}}</span>	
						</div>
						<div style="padding-top: 10px;display: flex;justify-content: space-between;">
						<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
						<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
						</div>
					</el-card>
					</div>
					</div>
					
			
    </el-carousel-item>		
  </el-carousel>
					
				 </div>
				<div v-else>
					<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
				</div>
				</div>
				
				
				<div class="fcltjcardstylephone">
				<div v-if="this.specialPriceFclList.length > 0 " style="margin: -15px;" >
				<div style="display: flex;flex-direction: column;">
				<div 
				:title="$t('m.tjcard.dc')"
				style="padding: 10px;"
				v-for="(item1,index) in specialPriceFclList"
				:key="item1.id"
				@click="fcltj(item1)"
				:class="{'ggg':item1.id==hoverIndex}"
				@mouseover="hoverIndex=item1.id"
				@mouseleave="hoverIndex = -1"
				>
				
				<el-card class="box-card-list" shadow="always" >
					<div style="display: flex;justify-content: space-between;">
					<span>{{item1.pol}}</span>
					<i class="iconfont icon-jiantou"></i>
					<span>{{item1.pod}}</span>
					</div>
					<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
					<span>{{`${'$' + item1['20GP'] + ' /'+'$' + item1['40GP']+ ' /' +'$'+ item1['40HQ']}`}}</span>	
					</div>
					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					<span>{{$t('m.tjcard.cq')}}:{{item1.sale_state}}</span>
				    <span>{{$t('m.tjcard.cgs')}}:{{item1.carrier}}</span>	
					</div>
					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
					<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
					</div>
				</el-card>
				</div>
				</div>
				</div>
				<div v-else>
					<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
				</div>
				
				
				</div>
				
				
		   </el-card>
	</div>
	
	
	
	
   	  </el-tab-pane>
   	  <el-tab-pane name="lcl">
	  <span slot="label"><i class="iconfont icon-kaifangshengtai"></i> {{$t('m.hypx')}}</span> 
		  <div class="lclstylepc">
		  	<div class="box-query">
		  		<span class="wz">{{$t('m.t.cong')}}</span>
		  		<el-select
				default-first-option
				class="zhselect"
		  		v-model="queryInfo.lclpol" 
		  		filterable
				:filter-method="lclPolFilterMethod"
				:loading="loadinglclPolSelect"
		  		:placeholder="$t('m.t.qxzselect')"
				>
		  		   <el-option
		  		   v-if="lclpolquery !== ''"
		  		      v-for="item in polLclList"
		  		      :key="item.pol"
		  		      :label="`${item.pol}  /  ${item.polcode }`"
		  		      :value="item.pol">
					  
					  <span style="float: left;margin-top:-10px">
					  <i class="iconfont icon-haiguangangkou"></i>{{ item.pol }}
					  </span>
					  <span style="float: left;
					  display:block;
					  position:absolute;
					  margin-top:15px;
					  font-size: 12px;
					  color:gray
					  ">
					  {{$t('m.t.Port')}}
					  {{ item.polzhname }}
					  </span>
					  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.polcode}}</span>
					  
		  		    </el-option>
		  		    
		  		     <el-option-group
		  		       v-if="lclpolquery == ''"
		  		          v-for="group in polLclList"
		  		          :key="group.label"
		  		          :label="group.label">
		  		          <el-option
		  		            v-for="item in group.options"
		  		            :key="item.label"
		  		            :label="`${item.label}  /  ${item.value }`"
		  		            :value="item.label">
		  		   		<span style="float: left;margin-top:-10px">
		  		   		<i class="iconfont icon-haiguangangkou"></i>
		  		   		{{ item.label }}
		  		   		</span>
		  		   		<span style="float: left;
		  		   		display:block;
		  		   		position:absolute;
		  		   		margin-top:15px;
		  		   		font-size: 12px;
		  		   		color:gray
		  		   		">
		  		   		{{$t('m.t.Port')}}
		  		   		{{ item.zhlabel }}
		  		   		</span>
		  		   		<span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
		  		          </el-option>
		  		        </el-option-group>
		  		    
					
					
					
		  		  </el-select>
		  		  <img src="../../assets/img/right.png" alt="" width="50px" height="40px">
		  		  <span class="wz">{{$t('m.t.dao')}}</span>
		  		  <el-select
				  default-first-option
				  @keyup.enter.native="queryLclShow"
				  @focus="focuslclpod"
				  class="zhselect"
		  		  v-model="queryInfo.lclpod" 
		  		  filterable
				  :filter-method="lclPodFilterMethod"
				  :loading="loadinglclPodSelect"
		  		  :placeholder="$t('m.t.qxzselect')"
				  >
		  		    <el-option
		  		    v-if="lclpodquery !== ''"
		  		      v-for="item in podLclList"
		  		      :key="item.pod"
		  		      :label="`${item.pod}  /  ${item.podcode }`"
		  		      :value="item.pod">
					  <span style="float: left;margin-top:-10px">
					  <i class="iconfont icon-haiguangangkou"></i>{{ item.pod }}
					  </span>
					  <span style="float: left;
					  display:block;
					  position:absolute;
					  margin-top:15px;
					  font-size: 12px;
					  color:gray
					  ">
					  {{$t('m.t.Port')}}
					  {{ item.podzhname }}
					  </span>
					  
					  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.podcode}}</span>
		  		    </el-option>
		  		    						  							
		  		    						  							<el-option-group
		  		    						  							  v-if="lclpodquery == ''"
		  		    						  							     v-for="group in podLclList"
		  		    						  							     :key="group.label"
		  		    						  							     :label="group.label">
		  		    						  							     <el-option
		  		    						  							       v-for="item in group.options"
		  		    						  							       :key="item.label"
		  		    						  							       :label="`${item.label}  /  ${item.value }`"
		  		    						  							       :value="item.label">
		  		    						  								  <span style="float: left;margin-top:-10px">
		  		    						  								  <i class="iconfont icon-haiguangangkou"></i>
		  		    						  								  {{ item.label }}
		  		    						  								  </span>
		  		    						  								  <span style="float: left;
		  		    						  								  display:block;
		  		    						  								  position:absolute;
		  		    						  								  margin-top:15px;
		  		    						  								  font-size: 12px;
		  		    						  								  color:gray
		  		    						  								  ">
		  		    						  								  {{$t('m.t.Port')}}
		  		    						  								  {{ item.zhlabel }}
		  		    						  								  </span>
		  		    						  								  					
		  		    						  								  
		  		    						  								  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
		  		    						  								   
		  		    						  							     </el-option>
		  		    						  							   </el-option-group>
		  		    </el-select>
		  </div>
		  <div style="height:72px;display: flex;margin:6px 0;">
		  	<el-button 
		  	type="primary" 
		  	icon="el-icon-search"  
		  	style="margin-left:30px;width: 200px;margin:0 20px"
		  	 @click="queryLclShow">{{$t('m.t.Search')}}</el-button>
			<span
			style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
			<img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
			</span>
		  	</div>
			</div>
			
			<div class="lclstylephone">
				<div class="box-query">
					<span class="wz">{{$t('m.t.cong')}}</span>
					<el-select
					default-first-option
					class="zhselect"
					v-model="queryInfo.lclpol" 
					filterable
					:filter-method="lclPolFilterMethod"
					:loading="loadinglclPolSelect"
					:placeholder="$t('m.t.qxzselect')"
					>
					   <el-option
					   v-if="lclpolquery !== ''"
					      v-for="item in polLclList"
					      :key="item.pol"
					      :label="`${item.pol}  /  ${item.polcode }`"
					      :value="item.pol">
						  
						  <span style="float: left;margin-top:-10px">
						  <i class="iconfont icon-haiguangangkou"></i>{{ item.pol }}
						  </span>
						  <span style="float: left;
						  display:block;
						  position:absolute;
						  margin-top:15px;
						  font-size: 12px;
						  color:gray
						  ">
						  {{$t('m.t.Port')}}
						  {{ item.polzhname }}
						  </span>
						  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.polcode}}</span>
						  
					    </el-option>
					    
					     <el-option-group
					       v-if="lclpolquery == ''"
					          v-for="group in polLclList"
					          :key="group.label"
					          :label="group.label">
					          <el-option
					            v-for="item in group.options"
					            :key="item.label"
					            :label="`${item.label}  /  ${item.value }`"
					            :value="item.label">
					   		<span style="float: left;margin-top:-10px">
					   		<i class="iconfont icon-haiguangangkou"></i>
					   		{{ item.label }}
					   		</span>
					   		<span style="float: left;
					   		display:block;
					   		position:absolute;
					   		margin-top:15px;
					   		font-size: 12px;
					   		color:gray
					   		">
					   		{{$t('m.t.Port')}}
					   		{{ item.zhlabel }}
					   		</span>
					   		<span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
					          </el-option>
					        </el-option-group>
					  </el-select>
				</div>
				<span style="margin-left: 30px;">——</span>
				<div class="box-query">
					<span class="wz">{{$t('m.t.dao')}}</span>
					<el-select
					default-first-option
					@keyup.enter.native="queryLclShow"
					@focus="focuslclpod"
					class="zhselect"
					v-model="queryInfo.lclpod" 
					filterable
					:filter-method="lclPodFilterMethod"
					:loading="loadinglclPodSelect"
					:placeholder="$t('m.t.qxzselect')"
					>
					  <el-option
					  v-if="lclpodquery !== ''"
					    v-for="item in podLclList"
					    :key="item.pod"
					    :label="`${item.pod}  /  ${item.podcode }`"
					    :value="item.pod">
										  <span style="float: left;margin-top:-10px">
										  <i class="iconfont icon-haiguangangkou"></i>{{ item.pod }}
										  </span>
										  <span style="float: left;
										  display:block;
										  position:absolute;
										  margin-top:15px;
										  font-size: 12px;
										  color:gray
										  ">
										  {{$t('m.t.Port')}}
										  {{ item.podzhname }}
										  </span>
										  
										  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.podcode}}</span>
					  </el-option>
					  						  							
					  						  							<el-option-group
					  						  							  v-if="lclpodquery == ''"
					  						  							     v-for="group in podLclList"
					  						  							     :key="group.label"
					  						  							     :label="group.label">
					  						  							     <el-option
					  						  							       v-for="item in group.options"
					  						  							       :key="item.label"
					  						  							       :label="`${item.label}  /  ${item.value }`"
					  						  							       :value="item.label">
					  						  								  <span style="float: left;margin-top:-10px">
					  						  								  <i class="iconfont icon-haiguangangkou"></i>
					  						  								  {{ item.label }}
					  						  								  </span>
					  						  								  <span style="float: left;
					  						  								  display:block;
					  						  								  position:absolute;
					  						  								  margin-top:15px;
					  						  								  font-size: 12px;
					  						  								  color:gray
					  						  								  ">
					  						  								  {{$t('m.t.Port')}}
					  						  								  {{ item.zhlabel }}
					  						  								  </span>
					  						  								  					
					  						  								  
					  						  								  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
					  						  								   
					  						  							     </el-option>
					  						  							   </el-option-group>
					  </el-select>
				</div>
				
				
				<el-button
				type="primary" 
				icon="el-icon-search"  
				style="margin-left:30px;width: 200px;margin:15px 20px"
				 @click="queryLclShow">{{$t('m.t.Search')}}</el-button>
				
				
				
			</div>
			
			
			
			
			
			<div class="tjcard">
				   <el-card class="boxtjcard" shadow="always">
					   <div slot="header" class="clearfix">
					       <span>{{$t('m.t.jrthhx')}}</span>
					     </div>
					<!-- 海运拼箱 -->
						 <div class="lcltjcardstyle">
					<div v-if="this.specialPriceLclList.length > 0" style="margin: -15px;">
					
<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
	<el-carousel-item v-for="item in Math.ceil(this.specialPriceLclList.length / 6)" :key="item.id">						
					
					 				<div style="display: flex;flex-wrap: wrap;">
					 				<div 
					 				style="padding:10px"
									v-for="(item1,index) in specialPriceLclList.slice((item-1) * 6,item*6)"
									:key="item1.id"
									v-if="index<=5"
									:title="$t('m.tjcard.dc')"
									@click="lcltj(item1)"
									:class="{'ggg':item1.id==hoverIndex}"
									@mouseover="hoverIndex=item1.id"
									@mouseleave="hoverIndex = -1"
					 				>
					 				<el-card class="box-card-list" shadow="always">
					 					<div style="display: flex;justify-content: space-between;">
					 					<span>{{item1.pol}}</span>
					 					<i class="iconfont icon-jiantou"></i>
					 					<span>{{item1.pod}}</span>
					 					</div>
										<div style="padding-top: 10px;display: flex;justify-content: space-between;">
										   <div style="color: #FF0000;font-weight: bold;">
											<span>{{item1['volume']}} / CMB:{{`${'$' + item1['freight_cmb']}`}} / TON:{{`${'$' + item1['freight_ton']}`}}</span>
											</div>
											<span>{{$t('m.tjcard.gj')}}:{{item1.country}}</span>
										</div>
					 					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					 						<span>{{$t('m.tjcard.yjhc')}}:{{item1.t_t}}</span>
					 						<span>{{$t('m.tjcard.khr')}}:{{item1.etd}}</span>
					 					</div>
					 					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					 					<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
					 					<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
					 					</div>
					 				</el-card>
					 				</div>
					 				</div>
									
									</el-carousel-item>
									</el-carousel>
														
					 </div>
						<div v-else>
							<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
						</div>
						</div>
						
						<div class="lcltjcardstylephone">
							<div v-if="this.specialPriceLclList.length > 0 " style="margin: -15px;" >
						<div style="display: flex;flex-direction: column;">
						<div 
						style="padding:10px"
						v-for="(item1,index) in specialPriceLclList"
						:key="item1.id"
						v-if="index<=5"
						:title="$t('m.tjcard.dc')"
						@click="lcltj(item1)"
						:class="{'ggg':item1.id==hoverIndex}"
						@mouseover="hoverIndex=item1.id"
						@mouseleave="hoverIndex = -1"
						>
						<el-card class="box-card-list" shadow="always">
							<div style="display: flex;justify-content: space-between;">
							<span>{{item1.pol}}</span>
							<i class="iconfont icon-jiantou"></i>
							<span>{{item1.pod}}</span>
							</div>
							<div style="padding-top: 10px;display: flex;justify-content: space-between;">
							   <div style="color: #FF0000;font-weight: bold;">
								<span>{{item1['volume']}} / CMB:{{`${'$' + item1['freight_cmb']}`}} / TON:{{`${'$' + item1['freight_ton']}`}}</span>
								</div>
								<span>{{$t('m.tjcard.gj')}}:{{item1.country}}</span>
							</div>
							<div style="padding-top: 10px;display: flex;justify-content: space-between;">
								<span>{{$t('m.tjcard.yjhc')}}:{{item1.t_t}}</span>
								<span>{{$t('m.tjcard.khr')}}:{{item1.etd}}</span>
							</div>
							<div style="padding-top: 10px;display: flex;justify-content: space-between;">
							<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
							<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
							</div>
						</el-card>
						</div>
						</div>	
							
							
								</div>
								<div v-else>
									<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
								</div>
								
						</div>
						
						
						
						
						
				   </el-card>
			</div>
	  </el-tab-pane>
   	  <el-tab-pane name="air">
	   <span slot="label"><i class="iconfont icon-icon-"></i> {{$t('m.ky')}}</span> 
		 <div class="airstylepc">
		 	<div class="box-query">
		 		<span class="wz">{{$t('m.t.cong')}}</span>
		 		<el-select
				default-first-option
		 		class="xgselect"
		 		v-model="queryInfo.airpol" 
		 		filterable
		 		:filter-method="airPolFilterMethod"
		 		:loading="loadingairPolSelect"
		 		:placeholder="$t('m.t.qxzselect')"
		 		>
		 		
		 		<el-option
		 		v-if="airpolquery !== ''"
		 		   v-for="item in polAirList"
		 		   :key="item.pol"
		 		   :label="`${item.polcode }  /  ${item.pol} `"
		 		   :value="item.polcode">
		 			<span style="float: left;margin-top:-10px">
		 			<i class="iconfont icon-airplane37"></i>{{ item.polcode }}
		 			</span>
		 			<span style="float: left;
		 			display:block;
		 			position:absolute;
		 			margin-top:15px;
		 			font-size: 12px;
		 			color:gray
		 			">
		 			{{$t('m.t.Port')}}
		 			{{ item.polzhname }}
		 			</span>
		 			<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pol}}</span>
		 			
		 		 </el-option>
		 		 
		 		  <el-option-group
		 		    v-if="airpolquery == ''"
		 		       v-for="group in polAirList"
		 		       :key="group.label"
		 		       :label="group.label">
		 		       <el-option
		 		         v-for="item in group.options"
		 		         :key="item.label"
		 		         :label="`${item.value }  /  ${item.label}`"
		 		         :value="item.value">
						 <span style="float: left;margin-top:-10px">
						 <i class="iconfont icon-airplane37"></i>
						 {{ item.value }}
						 </span>
						 <span style="float: left;
						 display:block;
						 position:absolute;
						 margin-top:15px;
						 font-size: 12px;
						 color:gray
						 ">
						 {{$t('m.t.Port')}}
						 {{ item.zhlabel }}
						 </span>
						 <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
						 
		 		       </el-option>
		 		     </el-option-group>
		 		 
		 		 
		 		 
		 		 
		 		  </el-select>
		 		  <img src="../../assets/img/right.png" alt="" width="50px" height="40px">
		 		  <span class="wz">{{$t('m.t.dao')}}</span>
				  
				  
		 		 <el-select
				 @keyup.enter.native="queryAirShow"
				 default-first-option
				 @focus="focusairpod"
		 		 class="xgselect"
		 		 v-model="queryInfo.airpod" 
		 		 filterable
		 		 :placeholder="$t('m.t.qxzselect')"
				 :filter-method="airPodFilterMethod"
		 		 :loading="loadingairPodSelect"
		 		 >
		 		     <el-option
		 		 							  v-if="airpodquery !== ''"
		 		       v-for="item in podAirList"
		 		       :key="item.pod"
		 		       :label="`${item.podcode }  /  ${item.pod}`"
		 		       :value="item.podcode">
					   
					   
					   <span style="float: left;margin-top:-10px">
					   <i class="iconfont icon-airplane37"></i>{{ item.podcode}}
					   </span>
					   <span style="float: left;
					   display:block;
					   position:absolute;
					   margin-top:15px;
					   font-size: 12px;
					   color:gray
					   ">
					   {{$t('m.t.Port')}}
					   {{ item.podzhname }}
					   </span>
					   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pod}}</span>
					   
		 		 		
		 		     </el-option>
		 		 							
		 		 							<el-option-group
		 		 							  v-if="airpodquery == ''"
		 		 							     v-for="group in podAirList"
		 		 							     :key="group.label"
		 		 							     :label="group.label">
		 		 							     <el-option
		 		 							       v-for="item in group.options"
		 		 							       :key="item.label"
		 		 							       :label="`${item.value }  /  ${item.label}`"
		 		 							       :value="item.value">
		 		 								 <span style="float: left;margin-top:-10px">
		 		 								 <i class="iconfont icon-airplane37"></i>
		 		 								 {{ item.value}}
		 		 								 </span>
		 		 								 <span style="float: left;
		 		 								 display:block;
		 		 								 position:absolute;
		 		 								 margin-top:15px;
		 		 								 font-size: 12px;
		 		 								 color:gray
		 		 								 ">
		 		 								 {{$t('m.t.Port')}}
		 		 								 {{ item.zhlabel }}
		 		 								 </span>
		 		 								 <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
		 		 								   
		 		 							     </el-option>
		 		 							   </el-option-group>
		 		 							
		 		 							
		 		   </el-select>
		 
		 </div>
		 <div style="height:72px;display: flex;margin:6px 0;">
		 	<el-button 
		 	type="primary" 
		 	icon="el-icon-search"  
		 	style="margin-left:30px;width: 200px;margin:0 20px"
			 @click="queryAirShow"
		 	 >{{$t('m.t.Search')}}</el-button>
			<span
			style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
			<img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
			</span>
		 	</div>
				</div>
				
				<div class="airstylephone">
					<div class="box-query">
						<span class="wz">{{$t('m.t.cong')}}</span>
						<el-select
						default-first-option
						class="xgselect"
						v-model="queryInfo.airpol" 
						filterable
						:filter-method="airPolFilterMethod"
						:loading="loadingairPolSelect"
						:placeholder="$t('m.t.qxzselect')"
						>
						
						<el-option
						v-if="airpolquery !== ''"
						   v-for="item in polAirList"
						   :key="item.pol"
						   :label="`${item.polcode }  /  ${item.pol} `"
						   :value="item.polcode">
							<span style="float: left;margin-top:-10px">
							<i class="iconfont icon-airplane37"></i>{{ item.polcode }}
							</span>
							<span style="float: left;
							display:block;
							position:absolute;
							margin-top:15px;
							font-size: 12px;
							color:gray
							">
							{{$t('m.t.Port')}}
							{{ item.polzhname }}
							</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pol}}</span>
							
						 </el-option>
						 
						  <el-option-group
						    v-if="airpolquery == ''"
						       v-for="group in polAirList"
						       :key="group.label"
						       :label="group.label">
						       <el-option
						         v-for="item in group.options"
						         :key="item.label"
						         :label="`${item.value }  /  ${item.label}`"
						         :value="item.value">
								 <span style="float: left;margin-top:-10px">
								 <i class="iconfont icon-airplane37"></i>
								 {{ item.value }}
								 </span>
								 <span style="float: left;
								 display:block;
								 position:absolute;
								 margin-top:15px;
								 font-size: 12px;
								 color:gray
								 ">
								 {{$t('m.t.Port')}}
								 {{ item.zhlabel }}
								 </span>
								 <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
								 
						       </el-option>
						     </el-option-group>
						 
						 
						 
						 
						  </el-select>
						</div>
						<span style="margin-left: 30px;">——</span>
					<div class="box-query">
						<span class="wz">{{$t('m.t.dao')}}</span>
						 
						 
						<el-select
						@keyup.enter.native="queryAirShow"
						default-first-option
						@focus="focusairpod"
						class="xgselect"
						v-model="queryInfo.airpod" 
						filterable
						:placeholder="$t('m.t.qxzselect')"
						:filter-method="airPodFilterMethod"
						:loading="loadingairPodSelect"
						>
						    <el-option
													  v-if="airpodquery !== ''"
						      v-for="item in podAirList"
						      :key="item.pod"
						      :label="`${item.podcode }  /  ${item.pod}`"
						      :value="item.podcode">
											   
											   
											   <span style="float: left;margin-top:-10px">
											   <i class="iconfont icon-airplane37"></i>{{ item.podcode}}
											   </span>
											   <span style="float: left;
											   display:block;
											   position:absolute;
											   margin-top:15px;
											   font-size: 12px;
											   color:gray
											   ">
											   {{$t('m.t.Port')}}
											   {{ item.podzhname }}
											   </span>
											   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pod}}</span>
											   
								
						    </el-option>
													
													<el-option-group
													  v-if="airpodquery == ''"
													     v-for="group in podAirList"
													     :key="group.label"
													     :label="group.label">
													     <el-option
													       v-for="item in group.options"
													       :key="item.label"
													       :label="`${item.value }  /  ${item.label}`"
													       :value="item.value">
														 <span style="float: left;margin-top:-10px">
														 <i class="iconfont icon-airplane37"></i>
														 {{ item.value}}
														 </span>
														 <span style="float: left;
														 display:block;
														 position:absolute;
														 margin-top:15px;
														 font-size: 12px;
														 color:gray
														 ">
														 {{$t('m.t.Port')}}
														 {{ item.zhlabel }}
														 </span>
														 <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
														   
													     </el-option>
													   </el-option-group>
													
													
						  </el-select>
						</div>
				<el-button
				type="primary" 
				icon="el-icon-search"  
				style="margin-left:30px;width: 200px;margin:15px 20px"
				 @click="queryAirShow"
				 >{{$t('m.t.Search')}}</el-button>		
						
				</div>
				
				
				
				
				
				
				
				
				
				
			<div class="tjcard">
				   <el-card class="boxtjcard" shadow="always">
					   <div slot="header" class="clearfix">
					       <span>{{$t('m.t.jrthhx')}}</span>
					     </div>
					<!-- 空运 -->
					
					<div class="airtjcardstyle">
					
					
					<div v-if="this.specialPriceAirList.length > 0" style="margin: -15px;">
					
					<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
						<el-carousel-item v-for="item in Math.ceil(this.specialPriceAirList.length / 6)" :key="item.id">	
					
					 				<div style="display: flex;flex-wrap: wrap;">
					 				<div
									:title="$t('m.tjcard.dc')"
									@click="airtj(item1)"
									:class="{'ggg':item1.id==hoverIndex}"
									@mouseover="hoverIndex=item1.id"
									@mouseleave="hoverIndex = -1"
					 				style="padding:10px"
									v-for="(item1,index) in specialPriceAirList.slice((item-1) * 6,item*6)"
									:key="item1.id"
									v-if="index<=5"
					 				>
					 				<el-card class="box-card-list" shadow="always">
					 					<div style="display: flex;color: blue;">
					 						<span>{{item1.pol}}</span>
					 						<i class="iconfont icon-jiantou"></i>
					 						<span>{{item1.pod}}</span>
					 					</div>
					 					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					 						<span>{{$t('m.tjcard.gj')}}:{{item1.country}}</span>
					 						<span>{{$t('m.tjcard.yjsx')}}:{{item1.t_t}}</span>
					 					</div>
					 					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					 						<span>{{$t('m.tjcard.hkgs')}}:{{item1.carrier}}</span>
					 						<span>{{$t('m.tjcard.hbrq')}}:{{item1.etd}}</span>
					 					</div>
					 					<div style="padding-top: 10px;display: flex;justify-content: space-between;">
					 						<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
					 						<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_fm}}</span>
					 					</div>
					 				</el-card>
					 				</div>
					 				</div>
									
								</el-carousel-item>
								</el-carousel>	
									
					 </div>
						<div v-else>
							<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
						</div>
						
						</div>
						
						<div>
							<div class="airtjcardstylephone" v-if="this.specialPriceAirList.length > 0" style="margin: -15px;">
							<div style="display: flex;flex-direction: column;">
							<div
							:title="$t('m.tjcard.dc')"
							@click="airtj(item1)"
							:class="{'ggg':item1.id==hoverIndex}"
							@mouseover="hoverIndex=item1.id"
							@mouseleave="hoverIndex = -1"
							style="padding:10px"
							v-for="(item1,index) in specialPriceAirList"
							:key="item1.id"
							v-if="index<=5"
							>
							<el-card class="box-card-list" shadow="always">
								<div style="display: flex;color: blue;">
									<span>{{item1.pol}}</span>
									<i class="iconfont icon-jiantou"></i>
									<span>{{item1.pod}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>{{$t('m.tjcard.gj')}}:{{item1.country}}</span>
									<span>{{$t('m.tjcard.yjsx')}}:{{item1.t_t}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>{{$t('m.tjcard.hkgs')}}:{{item1.carrier}}</span>
									<span>{{$t('m.tjcard.hbrq')}}:{{item1.etd}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>{{$t('m.tjcard.zzg')}}:{{item1.via}}</span>
									<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_fm}}</span>
								</div>
							</el-card>
							</div>
							</div>	
							</div>
							
							
							
						<div v-else>
							<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
						</div>	
						</div>
						
						
						
				   </el-card>
			</div>
			
			
			
			
			
			
			
			
			
	  </el-tab-pane>
	  <el-tab-pane name="railway">
	   <span slot="label"><i class="iconfont icon-ditie"></i> {{$t('m.t.tl')}}</span> 
				 <div class="railwaystylepc">
				 	<div class="box-query">
				 		<span class="wz">{{$t('m.t.cong')}}</span>
				 		<el-select 
				 		default-first-option						
				 		popper-class="railwayxgselect"
				 		class="railwayxgselect" 
				 		v-model="queryInfo.railroadpol" 
				 		filterable
				 		:filter-method="railroadpolFilterMethod"
				 		:loading="loadingrailroadpolSelect"
				 		:placeholder="$t('m.t.qxzselect')"
				 		>
				 		<el-option
				 		v-if="railroadpolquery !== ''"
				 		   v-for="item in railroadpolList"
				 		   :key="item.pol"
				 		   :label="`${item.pol}`"
				 		   :value="item.pol">
				 		   
				 		   <span style="float: left;">
				 		   <i class="iconfont icon-tielu"></i>
				 		   {{ item.pol }}
				 		   </span>
				 		 </el-option>
				 		 
				 		  <el-option-group
				 		    v-if="railroadpolquery == ''"
				 		       v-for="group in railroadpolList"
				 		       :key="group.label"
				 		       :label="group.label">
				 		       <el-option
				 		         v-for="item in group.options"
				 		         :key="item.label"
				 		         :label="`${item.label}`"
				 		         :value="item.label">
				 				 <span style="float: left;">
				 				 <i class="iconfont icon-tielu"></i>
				 				 {{ item.label }}
				 				 </span>
				 		       </el-option>
				 		     </el-option-group>
				 		 	
				 			
				 			
				 			
				 		</el-select>
				 		<img src="../../assets/img/right.png" alt="" width="50px" height="40px">
				 		<span class="wz">{{$t('m.t.dao')}}</span>
				 		<el-select
						 @keyup.enter.native="queryRailRoad"
						default-first-option
				 		 @focus="focusrailroadpod"
				 		popper-class="railwayxgselect"
				 		class="railwayxgselect" 
				 		v-model="queryInfo.railroadpod" 
				 		filterable 
				 		:filter-method="railroadpodFilterMethod"
				 		:loading="loadingrailroadpodSelect"
				 		:placeholder="$t('m.t.qxzselect')"
				 		>
				 		<el-option
				 		  v-if="railroadpodquery !== ''"
				 		    v-for="item in railroadpodList"
				 		    :key="item.pod"
				 		    :label="`${item.pod}`"
				 		    :value="item.pod">
				 			<span style="float: left;">
				 			<i class="iconfont icon-tielu"></i>{{ item.pod }}
				 			</span>
				 			
				 		  </el-option>
				 		
				 		<el-option-group
				 		  v-if="railroadpodquery == ''"
				 		     v-for="group in railroadpodList"
				 		     :key="group.label"
				 		     :label="group.label">
				 		     <el-option
				 		       v-for="item in group.options"
				 		       :key="item.value"
				 		       :label="`${item.label}`"
				 		       :value="item.label">
				 			  <span style="float: left;">
				 			  <i class="iconfont icon-tielu"></i>
				 			  {{ item.label }}
				 			  </span>
				 		     </el-option>
				 		   </el-option-group>
				 		</el-select>
				 	
				 	</div>
				 
				 <div style="height:72px;display: flex;margin:6px 0;">
				 	<el-button 
				 	type="primary" 
				 	icon="el-icon-search"  
				 	style="margin-left:30px;width: 200px;margin:0 20px"
					@click="queryRailRoad"
				 	>{{$t('m.t.Search')}}</el-button>
					<span
					style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
					<img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
					</span>
				 	</div>
					</div>
					
					
					<div class="railwaystylephone">
							<div class="box-query">
								<span class="wz">{{$t('m.t.cong')}}</span>
								<el-select 
								default-first-option						
								popper-class="railwayxgselect"
								class="railwayxgselect" 
								v-model="queryInfo.railroadpol" 
								filterable
								:filter-method="railroadpolFilterMethod"
								:loading="loadingrailroadpolSelect"
								:placeholder="$t('m.t.qxzselect')"
								>
								<el-option
								v-if="railroadpolquery !== ''"
								   v-for="item in railroadpolList"
								   :key="item.pol"
								   :label="`${item.pol}`"
								   :value="item.pol">
								   
								   <span style="float: left;">
								   <i class="iconfont icon-tielu"></i>
								   {{ item.pol }}
								   </span>
								 </el-option>
								 
								  <el-option-group
								    v-if="railroadpolquery == ''"
								       v-for="group in railroadpolList"
								       :key="group.label"
								       :label="group.label">
								       <el-option
								         v-for="item in group.options"
								         :key="item.label"
								         :label="`${item.label}`"
								         :value="item.label">
										 <span style="float: left;">
										 <i class="iconfont icon-tielu"></i>
										 {{ item.label }}
										 </span>
								       </el-option>
								     </el-option-group>
								</el-select>
								</div>
								
									<span style="margin-left: 30px;">——</span>
								<div class="box-query">
									<span class="wz">{{$t('m.t.dao')}}</span>
									<el-select
									 @keyup.enter.native="queryRailRoad"
									default-first-option
									 @focus="focusrailroadpod"
									popper-class="railwayxgselect"
									class="railwayxgselect" 
									v-model="queryInfo.railroadpod" 
									filterable 
									:filter-method="railroadpodFilterMethod"
									:loading="loadingrailroadpodSelect"
									:placeholder="$t('m.t.qxzselect')"
									>
									<el-option
									  v-if="railroadpodquery !== ''"
									    v-for="item in railroadpodList"
									    :key="item.pod"
									    :label="`${item.pod}`"
									    :value="item.pod">
										<span style="float: left;">
										<i class="iconfont icon-tielu"></i>{{ item.pod }}
										</span>
										
									  </el-option>
									
									<el-option-group
									  v-if="railroadpodquery == ''"
									     v-for="group in railroadpodList"
									     :key="group.label"
									     :label="group.label">
									     <el-option
									       v-for="item in group.options"
									       :key="item.value"
									       :label="`${item.label}`"
									       :value="item.label">
										  <span style="float: left;">
										  <i class="iconfont icon-tielu"></i>
										  {{ item.label }}
										  </span>
									     </el-option>
									   </el-option-group>
									</el-select>
									</div>
									
							<el-button
							type="primary" 
							icon="el-icon-search"  
							style="margin-left:30px;width: 200px;margin:15px 20px"
							@click="queryRailRoad"
							>{{$t('m.t.Search')}}</el-button>		
									
								
					</div>
					
					
					
					
					
					
					
					
					<div class="tjcard">
							   <el-card class="boxtjcard" shadow="always">
								   <div slot="header" class="clearfix">
								       <span>{{$t('m.t.jrthhx')}}</span>
								     </div>
									 <div class="railwaytjcardstyle">
									<div v-if="this.specialPriceRailRoadList.length > 0 " style="margin: -15px;">
					<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
						<el-carousel-item v-for="item in Math.ceil(this.specialPriceRailRoadList.length / 6)" :key="item.id">			
										<div style="display: flex;flex-wrap: wrap;">
										<div 
										:title="$t('m.tjcard.dc')"
										style="padding: 10px;"
										v-for="(item1,index) in specialPriceRailRoadList.slice((item-1) * 6,item*6)"
										:key="item1.id"
										v-if="index<=5"
										@click="Railroadtj(item1)"
										:class="{'ggg':item1.id==hoverIndex}"
										@mouseover="hoverIndex=item1.id"
										@mouseleave="hoverIndex = -1"
										>
										
										<el-card class="box-card-list" shadow="always" >
											<div style="display: flex;justify-content: space-between;">
											<span>{{item1.pol}}</span>
											<i class="iconfont icon-jiantou"></i>
											<span>{{item1.pod}}</span>
											</div>
											<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
										<span>{{`${'$' + item1['40_coc'] + ' /'+'$' + item1['40_soc']+ ' /' +'$'+ item1['20_coc'] + ' /' +'$'+ item1['20_soc'] + ' /' +'$'+ item1['2_20soc']}`}}</span>	
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
											<span>{{$t('m.tjcard.bz')}}:{{item1.currency}}</span>
											<span>{{$t('m.tjcard.bl')}}:{{item1.squad}}</span>	
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
											<span>{{$t('m.tjcard.yjhc')}}:{{item1.t_t}}</span>
											<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
											</div>
										</el-card>
										</div>
										</div>
										
								
					    </el-carousel-item>		
					  </el-carousel>
										
									 </div>
									<div v-else>
										<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
									</div>
									</div>
									
									
									<div class="railwaytjcardstylephone">
										<div v-if="this.specialPriceRailRoadList.length > 0 " style="margin: -15px;">
										<div style="display: flex;flex-direction: column;">
										<div 
										:title="$t('m.tjcard.dc')"
										style="padding: 10px;"
										v-for="(item1,index) in specialPriceRailRoadList"
										:key="item1.id"
										v-if="index<=5"
										@click="Railroadtj(item1)"
										:class="{'ggg':item1.id==hoverIndex}"
										@mouseover="hoverIndex=item1.id"
										@mouseleave="hoverIndex = -1"
										>
										
										<el-card class="box-card-list" shadow="always" >
											<div style="display: flex;justify-content: space-between;">
											<span>{{item1.pol}}</span>
											<i class="iconfont icon-jiantou"></i>
											<span>{{item1.pod}}</span>
											</div>
											<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
										<span>{{`${'$' + item1['40_coc'] + ' /'+'$' + item1['40_soc']+ ' /' +'$'+ item1['20_coc'] + ' /' +'$'+ item1['20_soc'] + ' /' +'$'+ item1['2_20soc']}`}}</span>	
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
											<span>{{$t('m.tjcard.bz')}}:{{item1.currency}}</span>
											<span>{{$t('m.tjcard.bl')}}:{{item1.squad}}</span>	
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
											<span>{{$t('m.tjcard.yjhc')}}:{{item1.t_t}}</span>
											<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
											</div>
										</el-card>
										</div>
										</div>
											</div>
											<div v-else>
												<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
											</div>
									</div>
									
									
							   </el-card>
						</div>
					
					
					
	  </el-tab-pane>
		
	  
	  <el-tab-pane name="car">
	   <span slot="label"><i class="iconfont icon-huoche_zhuangche_o"></i> {{$t('m.t.nltc')}}</span> 
	  				 <div class="carstylepc" >
						 <div class="box-query">
						 	<span class="wz1">{{$t('m.t.gq')}}</span>
						 	<el-select 
							default-first-option
						 	popper-class="railwayxgselect"
						 	class="railwayxgselect" 
						 	v-model="queryInfo.dock" 
						 	filterable
						 	:filter-method="dockFilterMethod"
						 	:loading="loadingdockSelect"
						 	:placeholder="$t('m.t.qxzselect')"
						 	>
						 	<el-option
						 	v-if="dockquery !== ''"
						 	   v-for="item in dockList"
						 	   :key="item.dock"
						 	   :label="`${item.dock}`"
						 	   :value="item.dock">
						 	   
						 	   <span style="float: left;">
						 	   <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
						 	   {{ item.dock }}
						 	   </span>
						 	 </el-option>
						 	 
						 	  <el-option-group
						 	    v-if="dockquery == ''"
						 	       v-for="group in dockList"
						 	       :key="group.label"
						 	       :label="group.label">
						 	       <el-option
						 	         v-for="item in group.options"
						 	         :key="item.label"
						 	         :label="`${item.label}`"
						 	         :value="item.label">
						 			 <span style="float: left;">
						 			 <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
						 			 {{ item.label }}
						 			 </span>
						 	       </el-option>
						 	     </el-option-group>
						 	 	
						 		
						 		
						 		
						 	</el-select>
						 	<img src="../../assets/img/right.png" alt="" width="50px" height="40px">
						 	<span class="wz2">{{$t('m.t.mddz')}}</span>
						 	<el-select
							 @keyup.enter.native="queryTrailerShow"
							 @focus="focusTrailerpod"
							 default-first-option
						 	popper-class="railwayxgselect"
						 	class="railwayxgselect" 
						 	v-model="queryInfo.trailer_door_point" 
						 	filterable 
						 	:filter-method="trailer_door_pointFilterMethod"
						 	:loading="loadingtrailer_door_pointSelect"
						 	:placeholder="$t('m.t.qxzselect')"
						 	>
						 	<el-option
						 	  v-if="trailer_door_pointquery !== ''"
						 	    v-for="item in trailer_door_pointList"
						 	    :key="item.trailer_door_point"
						 	    :label="`${item.trailer_door_point}`"
						 	    :value="item.trailer_door_point">
						 		<span style="float: left;">
						 		<i class="iconfont icon-icon_Shipped-zhuangtai"></i>{{ item.trailer_door_point }}
						 		</span>
						 		
						 	  </el-option>
						 	
						 	<el-option-group
						 	  v-if="trailer_door_pointquery == ''"
						 	     v-for="group in trailer_door_pointList"
						 	     :key="group.label"
						 	     :label="group.label">
						 	     <el-option
						 	       v-for="item in group.options"
						 	       :key="item.value"
						 	       :label="`${item.label}`"
						 	       :value="item.label">
						 		  <span style="float: left;">
						 		  <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
						 		  {{ item.label }}
						 		  </span>
						 	     </el-option>
						 	   </el-option-group>
						 	</el-select>
						 
						 </div>
						 <div style="height:72px;display: flex;margin:6px 0;">					 
	  				 	<el-button 
	  				 	type="primary" 
	  				 	icon="el-icon-search"  
	  				 	style="margin-left:30px;width: 200px;margin:0 20px"
	  				 	 @click="queryTrailerShow">{{$t('m.t.Search')}}</el-button>
						<span
						style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
						<img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
						</span>
	  				 	</div>
						</div>
						
					<div class="carstylephone">
						 <div class="box-query">
							<span class="wz1">{{$t('m.t.gq')}}</span>
							<el-select 
							default-first-option
							popper-class="railwayxgselect"
							class="railwayxgselect" 
							v-model="queryInfo.dock" 
							filterable
							:filter-method="dockFilterMethod"
							:loading="loadingdockSelect"
							:placeholder="$t('m.t.qxzselect')"
							>
							<el-option
							v-if="dockquery !== ''"
							   v-for="item in dockList"
							   :key="item.dock"
							   :label="`${item.dock}`"
							   :value="item.dock">
							   
							   <span style="float: left;">
							   <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
							   {{ item.dock }}
							   </span>
							 </el-option>
							 
							  <el-option-group
							    v-if="dockquery == ''"
							       v-for="group in dockList"
							       :key="group.label"
							       :label="group.label">
							       <el-option
							         v-for="item in group.options"
							         :key="item.label"
							         :label="`${item.label}`"
							         :value="item.label">
									 <span style="float: left;">
									 <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
									 {{ item.label }}
									 </span>
							       </el-option>
							     </el-option-group>
							</el-select> 
								</div>
									 <span style="margin-left: 30px;">——</span>
							  <div class="box-query">
								<span class="wz1">{{$t('m.t.mddz')}}</span>
								<el-select
								 @keyup.enter.native="queryTrailerShow"
								 @focus="focusTrailerpod"
								 default-first-option
								popper-class="railwayxgselect"
								class="railwayxgselect" 
								v-model="queryInfo.trailer_door_point" 
								filterable 
								:filter-method="trailer_door_pointFilterMethod"
								:loading="loadingtrailer_door_pointSelect"
								:placeholder="$t('m.t.qxzselect')"
								>
								<el-option
								  v-if="trailer_door_pointquery !== ''"
								    v-for="item in trailer_door_pointList"
								    :key="item.trailer_door_point"
								    :label="`${item.trailer_door_point}`"
								    :value="item.trailer_door_point">
									<span style="float: left;">
									<i class="iconfont icon-icon_Shipped-zhuangtai"></i>{{ item.trailer_door_point }}
									</span>
									
								  </el-option>
								
								<el-option-group
								  v-if="trailer_door_pointquery == ''"
								     v-for="group in trailer_door_pointList"
								     :key="group.label"
								     :label="group.label">
								     <el-option
								       v-for="item in group.options"
								       :key="item.value"
								       :label="`${item.label}`"
								       :value="item.label">
									  <span style="float: left;">
									  <i class="iconfont icon-icon_Shipped-zhuangtai"></i>
									  {{ item.label }}
									  </span>
								     </el-option>
								   </el-option-group>
								</el-select>  
								  
								  	</div>	
									<el-button
									type="primary" 
									icon="el-icon-search"  
									style="margin-left:30px;width: 200px;margin:15px 20px"
									 @click="queryTrailerShow">{{$t('m.t.Search')}}</el-button>
					</div>	
						
						
						
						
						
						
						
						
						
			<div class="tjcard">
							   <el-card class="boxtjcard" shadow="always">
								   <div slot="header" class="clearfix">
								       <span>{{$t('m.t.jrthhx')}}</span>
								     </div>
							<div class="cartjcardstyle">
								<div v-if="this.specialPriceTrailerList.length > 0" style="margin: -15px;">
								
			<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
				<el-carousel-item v-for="item in Math.ceil(this.specialPriceTrailerList.length / 6)" :key="item.id">						
								
								 				<div style="display: flex;flex-wrap: wrap;">
								 				<div 
												:title="$t('m.tjcard.dc')"
								 				style="padding:10px"
												@click="trailertj(item1)"
												:class="{'ggg':item1.id==hoverIndex}"
												@mouseover="hoverIndex=item1.id"
												@mouseleave="hoverIndex = -1"
												v-for="(item1,index) in specialPriceTrailerList.slice((item-1) * 6,item*6)"
												:key="item1.id"
												v-if="index<=5"
								 				>
								 				<el-card class="box-card-list" shadow="always">
													<div  style="padding: 30px 0 30px 0;">
								 					<div style="display: flex;justify-content: space-between;">
								 					<span>{{item1.dock}}</span>
								 					<i class="iconfont icon-jiantou"></i>
								 					<span>{{item1.trailer_door_point}}</span>
								 					</div>
													<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													   <div style="color: #FF0000;font-weight: bold;">
														<span>{{`${'￥' + item1['20GP'] + ' /'+'￥' + item1['40GP'] + ' /' +'￥'+ item1['40HQ']}`}}</span>
														</div>
															<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
													</div>
								 		</div>
								 				</el-card>
								 				</div>
								 				</div>
												
												</el-carousel-item>
												</el-carousel>
																	
								 </div>
									<div v-else>
										<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
									</div>
									</div>
									
									<div class="cartjcardstylephone">
										<div v-if="this.specialPriceTrailerList.length > 0" style="margin: -15px;">
										<div style="display: flex;flex-direction: column;">
												<div 
												:title="$t('m.tjcard.dc')"
												style="padding:10px"
												@click="trailertj(item1)"
												:class="{'ggg':item1.id==hoverIndex}"
												@mouseover="hoverIndex=item1.id"
												@mouseleave="hoverIndex = -1"
												v-for="(item1,index) in specialPriceTrailerList"
												:key="item1.id"
												v-if="index<=5"
												>
												<el-card class="box-card-list" shadow="always">
													<div  style="padding: 30px 0 30px 0;">
													<div style="display: flex;justify-content: space-between;">
													<span>{{item1.dock}}</span>
													<i class="iconfont icon-jiantou"></i>
													<span>{{item1.trailer_door_point}}</span>
													</div>
													<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													   <div style="color: #FF0000;font-weight: bold;">
														<span>{{`${'￥' + item1['20GP'] + ' /'+'￥' + item1['40GP'] + ' /' +'￥'+ item1['40HQ']}`}}</span>
														</div>
															<span>{{$t('m.tjcard.sxr')}}:{{item1.valid_to}}</span>	
													</div>
										</div>
												</el-card>
												</div>
												</div>
										</div>
										<div v-else>
											<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
										</div>
									</div>
						
									
									
									
							   </el-card>
						</div>			
	  </el-tab-pane>
	  
<!-- 国际快递 -->	  
	<el-tab-pane name="delivery">
	 <span slot="label"><i class="iconfont icon-swticonkuaidi" ></i> {{$t('m.t.gjkd')}}</span> 
	
				<div class="expressstylepc">
						  <span class="wz3" style="margin-left: 20px;">{{$t('m.express.to')}}</span>
					     <div class="box-query1">
						  <el-select
						  @keyup.enter.native="queryShowExpress"
						  default-first-option
						  @focus="focusexpresspod"
						  popper-class="xgselect"
						  class="xgselect"
						  v-model="queryInfo.expresspod" 
						  filterable
						  :placeholder="$t('m.t.qxzselect')"
				          :filter-method="expresspodFilterMethod"
						  :loading="loadingexpressPodSelect"
						  >
						      <el-option
							  v-if="expresspodquery !== ''"
						        v-for="item in destinationList"
						        :key="item.country_en"
						        :label="`${item.country_en}  /  ${item.country_code }`"
						        :value="item.country_en">
								
								
								<span style="float: left;margin-top:-10px">
								<i class="iconfont icon-kuaidi"  style="padding-right: 5px;"></i>{{ item.country_en }}
								</span>
								<span style="float: left;
								display:block;
								position:absolute;
								margin-top:15px;
								font-size: 12px;
								color:gray
								">
								 {{$t('m.express.country')}}
								{{ item.country_zh }}
								</span>
								
								<span style="float: right; color: #8492a6; font-size: 13px">{{ item.country_code}}</span>
								
						      </el-option>
							
							<el-option-group
							  v-if="expresspodquery == ''"
							     v-for="group in destinationList"
							     :key="group.label"
							     :label="group.label">
							     <el-option
							       v-for="item in group.options"
							       :key="item.value"
							       :label="`${item.label}  /  ${item.value }`"
							       :value="item.label">
								  <span style="float: left;margin-top:-10px">
								  <i class="iconfont icon-kuaidi" style="padding-right: 5px;"></i>
								  {{ item.label }}
								  </span>
								  <span style="float: left;
								  display:block;
								  position:absolute;
								  margin-top:15px;
								  font-size: 12px;
								  color:gray
								  ">
								  {{$t('m.express.country')}}
								  {{ item.zhlabel }}
								  </span>
								  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
								   
							     </el-option>
							   </el-option-group>
							
							
						    </el-select>
				
				</div>
				  <span class="wz3" style="padding: 0 25px 0 20px;">{{$t('m.express.weight')}}</span>
				  <el-input-number 
				  class="inputnumberclass"
				   @keyup.enter.native="queryShowExpress"
				  placeholder="KG"
				  v-model="queryInfo.num" 
				  :precision="1" 
				  :min="0"
				  :step="0.1" >
					  
				  </el-input-number>
				 <div style="height:72px;display: flex;margin:6px 0;">
					<el-button
					type="primary"
					icon="el-icon-search"  
					style="margin-left:30px;width: 200px;margin:0 20px"
					 @click="queryShowExpress">{{$t('m.express.inquiry')}}</el-button>
					 <span
					 style="border:1px solid #E5E5E5;border-radius: 7px;box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15) !important;">
					 <img src="../../assets/img/gzh.png" alt="" width="200px" height="72px"/>
					 </span>
					</div>
					</div>	
						
						
						
						<div class="expressstylephone">
						
							<div class="box-query1">
									<span class="wz1">{{$t('m.express.to')}}</span>
								<el-select
								@keyup.enter.native="queryShowExpress"
								default-first-option
								@focus="focusexpresspod"
								popper-class="xgselect"
								class="xgselect"
								v-model="queryInfo.expresspod" 
								filterable
								:placeholder="$t('m.t.qxzselect')"
								:filter-method="expresspodFilterMethod"
								:loading="loadingexpressPodSelect"
								>
								    <el-option
															  v-if="expresspodquery !== ''"
								      v-for="item in destinationList"
								      :key="item.country_en"
								      :label="`${item.country_en}  /  ${item.country_code }`"
								      :value="item.country_en">
																
																
																<span style="float: left;margin-top:-10px">
																<i class="iconfont icon-kuaidi"  style="padding-right: 5px;"></i>{{ item.country_en }}
																</span>
																<span style="float: left;
																display:block;
																position:absolute;
																margin-top:15px;
																font-size: 12px;
																color:gray
																">
																 {{$t('m.express.country')}}
																{{ item.country_zh }}
																</span>
																
																<span style="float: right; color: #8492a6; font-size: 13px">{{ item.country_code}}</span>
																
								    </el-option>
															
															<el-option-group
															  v-if="expresspodquery == ''"
															     v-for="group in destinationList"
															     :key="group.label"
															     :label="group.label">
															     <el-option
															       v-for="item in group.options"
															       :key="item.value"
															       :label="`${item.label}  /  ${item.value }`"
															       :value="item.label">
																  <span style="float: left;margin-top:-10px">
																  <i class="iconfont icon-kuaidi" style="padding-right: 5px;"></i>
																  {{ item.label }}
																  </span>
																  <span style="float: left;
																  display:block;
																  position:absolute;
																  margin-top:15px;
																  font-size: 12px;
																  color:gray
																  ">
																  {{$t('m.express.country')}}
																  {{ item.zhlabel }}
																  </span>
																  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
																   
															     </el-option>
															   </el-option-group>
															
															
								  </el-select>
								
							
								</div>
								<span style="margin: 30px;">——</span>
								<div>
								<span class="wz3" style="padding: 0 25px 0 20px;">{{$t('m.express.weight')}}</span>
								<el-input-number 
								class="inputnumberclass"
								 @keyup.enter.native="queryShowExpress"
								placeholder="KG"
								v-model="queryInfo.num" 
								:precision="1" 
								:min="0"
								:step="0.1" >
													  
								</el-input-number>
								</div>
								<el-button
								type="primary"
								icon="el-icon-search"  
								style="margin-left:30px;width: 200px;margin:15px 20px"
								 @click="queryShowExpress">{{$t('m.express.inquiry')}}</el-button>
								
								
						</div>
						
						
						
						
						
				<div class="tjcard">
						   <el-card class="boxtjcard" shadow="always">
							   <div slot="header" class="clearfix">
							       <span>{{$t('m.t.jrthhx')}}</span>
							     </div>
								 <!-- 国际快递 -->
								 
								 <div class="expresstjcardstyle">
								 
								<div v-if="this.specialPriceExpressList.length > 0 " style="margin: -15px;">
								
								
				<el-carousel :interval="5000" indicator-position="outside" :autoplay="true" height="350px">
					<el-carousel-item v-for="item in Math.ceil(this.specialPriceExpressList.length / 6)" :key="item.id">			
									<div style="display: flex;flex-wrap: wrap;">
									<div 
									:title="$t('m.tjcard.dc')"
									style="padding: 10px;"
									v-for="(item1,index) in specialPriceExpressList.slice((item-1) * 6,item*6)"
									:key="item1.id"
									v-if="index<=5"
									@click="expresstj(item1)"
									:class="{'ggg':item1.id==hoverIndex}"
									@mouseover="hoverIndex=item1.id"
									@mouseleave="hoverIndex = -1"
									>
									
									<el-card class="box-card-list" shadow="always" >
									<div style="display: flex;justify-content: space-between;">
										
										<div style="display: flex;">
										<span>{{item1.from}}</span>
										<i class="iconfont icon-jiantou"></i>
										<span>{{item1.to}}</span>
										</div>
										
										<span>{{$t('m.express.weight')}}:{{item1.weight}}</span>	
										
										
									</div>
									<div style="padding-top: 10px;display: flex;justify-content: space-between;">
										<span style="font-weight: bold;">{{$t('m.express.StandardPrice')}}:{{item1.special_cost}}</span>
										<span style="color: green;font-weight: bold;">{{$t('m.express.fuel')}}:{{item1.fuel}}</span>
									</div>
									<div style="padding-top: 10px;display: flex;justify-content: space-between;">
										<span>{{$t('m.express.discount')}}:{{item1.discount}}</span>
										<span style="color: red;font-weight: bold;">{{$t('m.express.totalcost')}}:{{item1.total_cost}}</span>
									</div>
									<div style="padding-top: 10px;display: flex;justify-content: space-between;">
										<span>{{$t('m.express.category')}}:{{item1.cate}}</span>
										<span>{{$t('m.express.sxrq')}}:{{item1.valid_to}}</span>
									</div>
									</el-card>
									</div>
									</div>
									
							
				    </el-carousel-item>		
				  </el-carousel>
									
								 </div>
								<div v-else>
									<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
								</div>
								</div>
								<div class="expresstjcardstylephone">
								<div v-if="this.specialPriceExpressList.length > 0 " style="margin: -15px;">
								<div style="display: flex;flex-direction: column;">
								<div 
								:title="$t('m.tjcard.dc')"
								style="padding: 10px;"
								v-for="(item1,index) in specialPriceExpressList"
								:key="item1.id"
								v-if="index<=5"
								@click="expresstj(item1)"
								:class="{'ggg':item1.id==hoverIndex}"
								@mouseover="hoverIndex=item1.id"
								@mouseleave="hoverIndex = -1"
								>
								
								<el-card class="box-card-list" shadow="always" >
								<div style="display: flex;justify-content: space-between;">
									
									<div style="display: flex;">
									<span>{{item1.from}}</span>
									<i class="iconfont icon-jiantou"></i>
									<span>{{item1.to}}</span>
									</div>
									
									<span>{{$t('m.express.weight')}}:{{item1.weight}}</span>	
									
									
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span style="font-weight: bold;">{{$t('m.express.StandardPrice')}}:{{item1.special_cost}}</span>
									<span style="color: green;font-weight: bold;">{{$t('m.express.fuel')}}:{{item1.fuel}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>{{$t('m.express.discount')}}:{{item1.discount}}</span>
									<span style="color: red;font-weight: bold;">{{$t('m.express.totalcost')}}:{{item1.total_cost}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>{{$t('m.express.category')}}:{{item1.cate}}</span>
									<span>{{$t('m.express.sxrq')}}:{{item1.valid_to}}</span>
								</div>
								</el-card>
								</div>
								</div>
								
								
									</div>
									<div v-else>
										<el-empty :description="$t('m.tjcard.nothhx')"></el-empty>
									</div>
								</div>
								
								
						   </el-card>
					</div>		
						
						
						
				
						
	</el-tab-pane>
	  
	  
   	</el-tabs>
   </div>
  
</div>
<!-- 我要订舱 -->
 <el-dialog
	 :close-on-click-modal="false"
	   center
	   :title="$t('m.entrustment.title')"
	   :visible.sync="dialogVisible"
	   :width="dtwdith"
	   >
	   <span style="text-align:center">{{$t('m.entrustment.selectMethod')}}</span>
	   <span slot="footer" class="dialog-footer">
		   <div  class="wydcStyle">
			   
			   <el-button   type="primary" class="wydcStylebtn"  @click="centerDialogVisible = true">{{$t('m.entrustment.selectone')}}</el-button>
			   <el-button   type="primary" class="wydcStylebtn"  @click="zskflx()">{{$t('m.entrustment.selecttwo')}}</el-button>
		   </div>
	  
	   </span>
	 </el-dialog>
	 <el-dialog
	   :title="$t('m.entrustment.entrustmentWrite.title')"
	   @close="dcDialogClosed"
	   :visible.sync="centerDialogVisible"
	   :width="centerDialogVisibleWidth"
	  :close-on-click-modal="false"
	  >
	   <el-form
	   :label-position="labelposition"
	   :rules="dcFormRules"
	   ref="dcFormRef"
	   :model="dcForm"
	   :label-width="labelwidth"
	   >
	   
	   <el-tabs v-model="cywtsactiveName" >
	      <el-tab-pane :label="$t('m.entrustment.entrustmentWrite.tabone')" name="txwts">
	   	   <el-form-item :label="$t('m.entrustment.entrustmentWrite.transportation')"  prop="transportation">
	   	       <el-radio-group v-model="dcForm.transportation" @change="transportationChange">
	   	         <el-radio label="海运整箱">{{$t('m.entrustment.entrustmentWrite.fcl')}}</el-radio>
	   	         <el-radio label="海运拼箱">{{$t('m.entrustment.entrustmentWrite.lcl')}}</el-radio>
	   	   			 <el-radio label="空运">{{$t('m.entrustment.entrustmentWrite.air')}}</el-radio>
	   	   			 <el-radio label="铁路">{{$t('m.entrustment.entrustmentWrite.railway')}}</el-radio>
	   	   			 <el-radio label="内陆拖车">{{$t('m.entrustment.entrustmentWrite.trailers')}}</el-radio>
					 <el-radio label="国际快递">{{$t('m.entrustment.entrustmentWrite.express')}}</el-radio>
	   	       </el-radio-group>
	   	     </el-form-item>
			 
			 
			 <div class="entrustmentpc">
	   	   		 <el-form-item :label="$t('m.entrustment.entrustmentWrite.boxVolume')"
	   	   		 v-if="this.dcForm.transportation !== '海运拼箱' && this.dcForm.transportation !== '空运' && this.dcForm.transportation !== '国际快递'"
	   	   		 prop="Box"
	   	   		 >
	   	   		 <div style="display: flex;flex-direction: column;">
	   	   		 <div style="display: flex;">
	   	   			 <div style="display: flex;flex-direction: column;margin-right: 80px;width:150px">
	   	   			 <span style="margin-top: -5px;">20GP</span>
	   	   			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:5.898*2.352*2.385 m</span>
	   	   			 </div>
	   	   			 <el-input-number
	   	   			 type="number"
	   	   			 v-model="dcForm.ershigp_num" 
	   	   			 :min="0" 
	   	   			 :max="999" 
	   	   			 ></el-input-number> 
	   	   		 </div>
	   	   		 <div style="display: flex;">
	   	   		 			 <div style="display: flex;flex-direction: column;margin-right: 75px;width:155px">
	   	   		 			 <span style="margin-top: -5px;">40GP</span>
	   	   		 			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:12.032*2.352*2.385 m</span>
	   	   		 			 </div>
	   	   		 			 <el-input-number v-model="dcForm.sishigp_num"  :min="0" :max="999" ></el-input-number> 
	   	   		 </div>
	   	   		 <div style="display: flex;">
	   	   		 			 <div style="display: flex;flex-direction: column;margin-right: 80px;width:150px">
	   	   		 			 <span style="margin-top: -5px;">40HQ</span>
	   	   		 			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:12.032*2.352*2.69 m</span>
	   	   		 			 </div>
	   	   		 			 <el-input-number v-model="dcForm.sishihq_num"  :min="0" :max="999" ></el-input-number> 
	   	   		 </div>
	   	   		 <div style="display: flex;">
	   	   		 			 <div style="width:85px;margin-right: 20px;">
	   	   		 			 <span>{{$t('m.entrustment.entrustmentWrite.OtherSize')}}:</span>
	   	   		 			 </div>
	   	   		 			<el-input v-model="dcForm.qtgg_num" :placeholder="$t('m.entrustment.entrustmentWrite.OtherSizeRequired')"></el-input>
	   	   		 </div>
	   	   		 </div>
	   	   		  </el-form-item>
	   	   		  <el-row :gutter="20">
	   	   			  <el-col :span="8">
	   	   			  <el-form-item :label="$t('m.entrustment.entrustmentWrite.mz') + ':'" prop="Gross_weight">
	   	   			      <el-input v-model="dcForm.Gross_weight" :placeholder="$t('m.entrustment.entrustmentWrite.mz')"></el-input>
	   	   			   </el-form-item>
	   	   			   </el-col>
	   	   			   <el-col :span="8">
	   	   			   <el-form-item :label="$t('m.entrustment.entrustmentWrite.tj') + ':'"  prop="Volume">
	   	   			       <el-input v-model="dcForm.Volume" :placeholder="$t('m.entrustment.entrustmentWrite.tj')"></el-input>
	   	   			    </el-form-item>
	   	   				  </el-col>
	   	   				<el-col :span="8">
	   	   			  			<el-form-item :label="$t('m.entrustment.entrustmentWrite.packages') + ':'"  prop="packages_num">
	   	   			  			    <el-input v-model="dcForm.packages_num" :placeholder="$t('m.entrustment.entrustmentWrite.packages')"></el-input>
	   	   			  			 </el-form-item>
	   	   						   </el-col>
	   	   			  </el-row>
					  </div>
					  
					  
					  <!-- 手机端 -->
					  <div class="entrustmentphone">
					  	   	   		 <el-form-item :label="$t('m.entrustment.entrustmentWrite.boxVolume')"
					  	   	   		 v-if="this.dcForm.transportation !== '海运拼箱' && this.dcForm.transportation !== '空运' && this.dcForm.transportation !== '国际快递'"
					  	   	   		 prop="Box"
					  	   	   		 >
					  	   	   		 <div style="display: flex;flex-direction: column;">
					  	   	   		 <div style="display: flex;flex-direction: column;">
					  	   	   			 <div style="display: flex;flex-direction: column;margin-right: 80px;width:150px">
					  	   	   			 <span style="margin-top: -5px;">20GP</span>
					  	   	   			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:5.898*2.352*2.385 m</span>
					  	   	   			 </div>
					  	   	   			 <el-input-number
					  	   	   			 type="number"
					  	   	   			 v-model="dcForm.ershigp_num" 
					  	   	   			 :min="0" 
					  	   	   			 :max="999" 
					  	   	   			 ></el-input-number> 
					  	   	   		 </div>
					  	   	   		 <div style="display: flex;flex-direction: column;">
					  	   	   		 			 <div style="display: flex;flex-direction: column;margin-right: 75px;width:155px">
					  	   	   		 			 <span style="margin-top: -5px;">40GP</span>
					  	   	   		 			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:12.032*2.352*2.385 m</span>
					  	   	   		 			 </div>
					  	   	   		 			 <el-input-number v-model="dcForm.sishigp_num"  :min="0" :max="999" ></el-input-number> 
					  	   	   		 </div>
					  	   	   		 <div style="display: flex;flex-direction: column;">
					  	   	   		 			 <div style="display: flex;flex-direction: column;margin-right: 80px;width:150px">
					  	   	   		 			 <span style="margin-top: -5px;">40HQ</span>
					  	   	   		 			 <span style="margin-top: -20px;color: gray;font-size: 12px;">{{$t('m.entrustment.entrustmentWrite.Inside')}}:12.032*2.352*2.69 m</span>
					  	   	   		 			 </div>
					  	   	   		 			 <el-input-number v-model="dcForm.sishihq_num"  :min="0" :max="999" ></el-input-number> 
					  	   	   		 </div>
					  	   	   		 <div style="display: flex;flex-direction: column;">
					  	   	   		 			 <div style="width:85px;margin-right: 20px;">
					  	   	   		 			 <span>{{$t('m.entrustment.entrustmentWrite.OtherSize')}}:</span>
					  	   	   		 			 </div>
					  	   	   		 			<el-input v-model="dcForm.qtgg_num" :placeholder="$t('m.entrustment.entrustmentWrite.OtherSizeRequired')"></el-input>
					  	   	   		 </div>
					  	   	   		 </div>
					  	   	   		  </el-form-item>
					  	   	   		  <div style="display: flex;flex-direction: column;">
					  	   	   			 
					  	   	   			  <el-form-item :label="$t('m.entrustment.entrustmentWrite.mz') + ':'" prop="Gross_weight">
					  	   	   			      <el-input v-model="dcForm.Gross_weight" :placeholder="$t('m.entrustment.entrustmentWrite.mz')"></el-input>
					  	   	   			   </el-form-item>
					  	   	   			
					  	   	   			 
					  	   	   			   <el-form-item :label="$t('m.entrustment.entrustmentWrite.tj') + ':'"  prop="Volume">
					  	   	   			       <el-input v-model="dcForm.Volume" :placeholder="$t('m.entrustment.entrustmentWrite.tj')"></el-input>
					  	   	   			    </el-form-item>
					  	   	   			
					  	   	   			
					  	   	   			  			<el-form-item :label="$t('m.entrustment.entrustmentWrite.packages') + ':'"  prop="packages_num">
					  	   	   			  			    <el-input v-model="dcForm.packages_num" :placeholder="$t('m.entrustment.entrustmentWrite.packages')"></el-input>
					  	   	   			  			 </el-form-item>
					  	   	   						 
					  	   	   				  </div>
					  					  </div>
					  
					  
					  
					  
	   	   		<el-form-item :label="$t('m.entrustment.entrustmentWrite.zwpm') + ':'" prop="zwpm">
	   	   		   <el-input v-model="dcForm.zwpm" :placeholder="$t('m.entrustment.entrustmentWrite.zwpm')"></el-input>
	   	   		 </el-form-item>
	   	   		 <el-form-item :label="$t('m.entrustment.entrustmentWrite.ywpm') + ':'" prop="ywpm">
	   	   		    <el-input v-model="dcForm.ywpm" :placeholder="$t('m.entrustment.entrustmentWrite.zwpm')"></el-input>
	   	   		  </el-form-item>
	   	   		  <el-form-item :label="$t('m.entrustment.entrustmentWrite.bm') + ':'" prop="hsbm">
	   	   		     <el-input v-model="dcForm.hsbm" :placeholder="$t('m.entrustment.entrustmentWrite.bm')"></el-input>
	   	   		   </el-form-item>
	   	   
	   	   <el-divider></el-divider>
	   	   <div style="margin-bottom: 20px;">
	   	   <el-tag>{{$t('m.entrustment.entrustmentWrite.fhrxx')}}</el-tag>
	   	   </div>
	   	   <el-form-item  prop="textareafhr">
	   	     <el-input
	   	   		  maxlength="1000"
	   	   		   show-word-limit
	   	       type="textarea"
	   	       :autosize="{ minRows: 6}"
	   	       :placeholder="$t('m.entrustment.entrustmentWrite.fhrxxRequired')"
	   	       v-model="dcForm.textareafhr">
	   	     </el-input>
	   	    </el-form-item>
	   	   		   <el-divider></el-divider>
	   	   		   <div style="margin-bottom: 20px;">
	   	   		   <el-tag  type="success">{{$t('m.entrustment.entrustmentWrite.shrxx')}}</el-tag>
	   	   		   </div>
	   	   		   <el-form-item  prop="textareashr">
	   	   		     <el-input
	   	   		   		  maxlength="1000"
	   	   		   		   show-word-limit
	   	   		       type="textarea"
	   	   		       :autosize="{ minRows: 6}"
	   	   		       :placeholder="$t('m.entrustment.entrustmentWrite.shrxxRequired')"
	   	   		       v-model="dcForm.textareashr">
	   	   		     </el-input>
	   	   		    </el-form-item>
	   	   		   		   <el-divider></el-divider>
	   	   		   		   <div style="margin-bottom: 20px;">
	   	   		   		   <el-tag  type="warning">{{$t('m.entrustment.entrustmentWrite.tzrxx')}}</el-tag>
	   	   		   		   </div>
	   	   				   <el-form-item  prop="textareatzr">
	   	   				     <el-input
	   	   				   		  maxlength="1000"
	   	   				   		   show-word-limit
	   	   				       type="textarea"
	   	   				       :autosize="{ minRows: 6}"
	   	   				       :placeholder="$t('m.entrustment.entrustmentWrite.tzrxxRequired')"
	   	   				       v-model="dcForm.textareatzr">
	   	   				     </el-input>
	   	   				    </el-form-item>
	      </el-tab-pane>
	      <el-tab-pane :label="$t('m.entrustment.entrustmentWrite.tabtwo')" name="szfj">
	   	   <el-form-item :label="$t('m.entrustment.entrustmentWrite.Upload')" prop="attachment">
	   	   			   <!-- http://127.0.0.1:3007/send/sendordershipmenttocustomer/ -->
	   	         <el-upload
	   	                      class="upload-demo"
	   	                      drag
	   	                      action="#"
	   	                      :limit="1"
	   	                      :auto-upload="true"
	   	                      ref="upload"
	   	                      :before-upload="beforeUpload"
	   						   :on-change="handleChange"
	   						   :before-remove="handleRemove"
	   						  :file-list="fileList"
	   	                    >
	   	                      <i class="el-icon-upload"></i>
	   	                      <div class="el-upload__text">{{$t('m.entrustment.entrustmentWrite.szwts')}}</div>
	   	                    </el-upload>
	   	           <el-button
	   	                        class="view"
	   	                        round
	   	                        size="small"
	   	                        @click="viewFile()"
	   	                      >{{$t('m.entrustment.entrustmentWrite.Preview')}}</el-button>
	   	   				
	   	   
	   	    </el-form-item>
	   	   		 
	      </el-tab-pane>
	    </el-tabs>
		 
		 
		   </el-form>
	   <span slot="footer" class="dialog-footer">
		 <el-button type="primary" @click="confirmdc">{{$t('m.entrustment.entrustmentWrite.Confirm')}}</el-button>
	     <el-button  @click="centerDialogVisible = false">{{$t('m.entrustment.entrustmentWrite.cancel')}}</el-button>
	 
	   </span>
	 </el-dialog> 





</div>
</template>

<script>
import { mapGetters } from 'Vuex'
export default {
  name: 'home',
  data() {
    return {
		List:[],
		activeName: 'fcl',
		//******海运整箱下拉数据***********
		timer:null,
		polquery:'',
		loadingPolSelect:false,
		pollist:[],
		polList:[
			{
			          label:this.$t('m.t.Hotports'),
			         options: [{
			           value: 'CNSHA',
			           label: 'SHANGHAI',
					   zhlabel:'上海'
			         }]
			        }
		],
		podquery:'',
		loadingPodSelect:false,
		podlist:[],
		podList:[],
		hoverIndex:-1,
		//*************海运拼箱***************
		loadinglclPolSelect:false,
		lclpolquery:'',
		polLcllist:[],
		polLclList:[
		{
		          label: this.$t('m.t.Hotports'),
		         options: [{
		           value: 'CNSHA',
		           label: 'SHANGHAI',
				   zhlabel:'上海'
		         }]
		        }	
		],
		lclpodquery:'',
		loadinglclPodSelect:false,
		podLcllist:[],
		podLclList:[],
		//*************空运***************
		loadingairPolSelect:false,
		airpolquery:'',
		polAirlist:[],
		polAirList:[
			{
			          label: this.$t('m.t.Hotports'),
			         options: [{
			           value: 'PVG',
			           label: 'SHANGHAI',
					   zhlabel:'上海'
			         }]
			        }
		],
		loadingairPodSelect:false,
		airpodquery:'',
		podAirlist:[],
		podAirList:[],
		
		//************************************
		//内陆拖车
		loadingdockSelect:false,
		dockquery:'',
		docklist:[],
		dockList:[
			{
			          label:  this.$t('m.t.Popularportarea'),
			         options: [{
			           value: '上海',
			           label: '上海',
					   zhlabel:'上海'
			         }]
			        }
		],
		
		//门点地址
		loadingtrailer_door_pointSelect:false,
		trailer_door_pointlist: [],
		trailer_door_pointList: [],
		trailer_door_pointquery:'',
		//*************铁路**********************
		loadingrailroadpolSelect:false,
		railroadpolquery:'',
		railroadpollist:[],
		railroadpolList:[
			{
			          label: this.$t('m.t.Hotports'),
			         options: [{
			           value: 'Suzhou苏州',
			           label: 'Suzhou苏州',
					   zhlabel:'Suzhou苏州'
			         },
					 {
					   value: 'Jinhua金华',
					   label: 'Jinhua金华',
					   zhlabel:'Jinhua金华'
					 },
					 {
					   value: `Xi'an西安`,
					   label: `Xi'an西安`,
					   zhlabel:`Xi'an西安`
					 },
					 {
					   value: 'Chengdu成都',
					   label: 'Chengdu成都',
					   zhlabel:'Chengdu成都'
					 },
					 {
					   value: 'Zhengzhou郑州',
					   label: 'Zhengzhou郑州',
					   zhlabel:'Zhengzhou郑州'
					 }
					 ]
			        }	
		],
		loadingrailroadpodSelect:false,
		railroadpodlist: [],
		railroadpodList: [],
		railroadpodquery:'',
		//国际快递
		expresspodquery:'',
		loadingexpressPodSelect:false,
		destinationlist:[],
		destinationList:[],
		
		
		//*****************
     queryInfo:{
     	pol:'',
     	pod:'',
		lclpol:'',
		lclpod:'',
		dock:'',
		trailer_door_point:'',
		railroadpol:'',
		railroadpod:'',
		airpol:'',
		airpod:'',
		expresspod:'',
		num:undefined
		
     },
	 //首页特价
     specialPriceFclList:[],
	 specialPriceLclList:[],
	 specialPriceAirList:[],
	 specialPriceTrailerList:[],
	 specialPriceRailRoadList:[],
	 specialPriceExpressList:[],
	 //************************
	 //查询价格
	 queryFclPodList:[],
	 
	 //切换卡片栏
	 cywtsactiveName:'txwts',
	 //上传文件
	 fileList:[],
	 fileData:'',
	 file:'',
	 fileName:'',
	 fileSize:'',
	 //出运委托书
	 dcData:'',
	 centerDialogVisible: false,
	 dialogVisible:false,
	 dcForm:{
	 	transportation:'',
	 	//箱型*箱数
	 	ershigp_num:0,
	 	sishigp_num:0,
	 	sishihq_num:0,
	 	qtgg_num:'',
	 	Gross_weight:'',
	 	Volume:'',
	 	packages_num:'',
	 	zwpm:'',
	 	ywpm:'',
	 	hsbm:'',
	 	//发货人
	 	textareafhr:'',
	 	//收货人
	 	textareashr:'',
	 	//通知人
	 	textareatzr:'',
	 },
	 //校验规则
	 dcFormRules:{
	 transportation:[
	 	{required:true,message:this.$t('m.entrustment.entrustmentWrite.qxztransportationRequired'),trigger:'change'},
	 ],
	 },
	 dtwdith:'30%',
	 centerDialogVisibleWidth:'70%',
	 labelposition:'right',
	 labelwidth:'160px'
    }
  },


	computed:{
	...mapGetters(['query_pod_fcl','query_pod_lcl','query_pod_air','query_pod_trailer','query_pod_railroad','query_pod_express','id']),
	queryFclPodhistorys(){
		return [...this.query_pod_fcl].reverse()
	},
	queryLclPodhistorys(){
		return [...this.query_pod_lcl].reverse()
	},
	queryAirPodhistorys(){
		return [...this.query_pod_air].reverse()
	},
	querytrailerPodhistorys(){
		return [...this.query_pod_trailer].reverse()
	},
	queryrailroadPodhistorys(){
		return [...this.query_pod_railroad].reverse()
	},
	queryExpressPodhistorys(){
		return [...this.query_pod_express].reverse()
	},
	tokenStr(){
		return window.sessionStorage.getItem('token')
	},
	},
  created() {
 // this.getList()
  this.getSpecialFclSaleList()
  },
  methods:{
	  //****海运整箱******
	  async getPolList(){
		const query = this.polquery
		if(query){
		const {data:res} = await this.$http.getManyTimesPortBySeaSelect({params:{query}})
		if (res.status !==0){
		 return this.$message.error('获取下拉列表数据失败!')
		}
		
		this.pollist = res.data.map(item => {
		  return { id: `${item.id}`, pol: `${item.portname}`,polcode:`${item.portcode}`,polzhname:`${item.portzhname}` };
		});
		this.polList = this.pollist.slice(0,10)	
		}
	 
		
	  },
	async  polFilterMethod(query){
		this.polquery = query
		  if (query !== '') {
			   this.loadingPolSelect = true;
			clearTimeout(this.timer)
			        this.timer = setTimeout(()=>{
						this.loadingPolSelect = false;
			        		this.getPolList()
			        	},200)     
		  } else {
		    this.polList = [
			{
			          label: this.$t('m.t.Hotports'),
			         options: [{
			           value: 'CNSHA',
			           label: 'SHANGHAI',
					   zhlabel:'上海'
			         }]
			        }		
			]; 
			
		  }  
		  
	  },
 async getPodList(){
		const query = this.podquery
			if(query){
	  	const {data:res} = await this.$http.getManyTimesPortBySeaSelect({params:{query}})
	  	if (res.status !==0){
	  	 return this.$message.error('获取下拉列表数据失败!')
	  	}
		this.podlist = res.data.map(item => {
		  return { id: `${item.id}`, pod: `${item.portname}`,podcode:`${item.portcode}`,podzhname:`${item.portzhname}` };
		});
		//console.log(this.podlist)
		this.podList = this.podlist.slice(0,10);
		}
	  },	  
async podFilterMethod(query){
	this.podquery = query
	  if (query !== '') {
		   this.loadingPodSelect = true;
		clearTimeout(this.timer)
		        this.timer = setTimeout(()=>{
					this.loadingPodSelect = false;
		        		this.getPodList()
		        	},200)     
	  } else {
	setTimeout(() => {
		
		if(this.tokenStr){
			this.podList = [
			{
			          label: this.$t('m.t.Basicport'),
			          options: [
											   		   {
											               value:  this.queryFclPodhistorys[0].split("/")[1],
											               label:  this.queryFclPodhistorys[0].split("/")[0],
											   			zhlabel:  this.queryFclPodhistorys[0].split("/")[2]
											             }, {
											              value: this.queryFclPodhistorys[1].split("/")[1],
											               label:  this.queryFclPodhistorys[1].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[1].split("/")[2]
											             },{
											              value: this.queryFclPodhistorys[2].split("/")[1],
											               label:   this.queryFclPodhistorys[2].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[2].split("/")[2]
											             },{
											             value:  this.queryFclPodhistorys[3].split("/")[1],
											              label:   this.queryFclPodhistorys[3].split("/")[0],
											             zhlabel:  this.queryFclPodhistorys[3].split("/")[2]
											             },{
											              value:  this.queryFclPodhistorys[4].split("/")[1],
											               label:   this.queryFclPodhistorys[4].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[4].split("/")[2]
											             }
										   
										   ]
			        }	
			]; 
			}else{
				this.podList = [
				{
				          label: this.$t('m.t.Basicport'),
				          options: [
												   		   {
												              value: 'IDBTM',
												              label: 'BATAM',
												              zhlabel:'巴淡'
												             }
											   ]
				        }	
				];
			}
			}, 200);  
		  
	  
	  } 
	
	
},  
focusfclpod(){
	if(this.tokenStr){
		if(this.podquery==''){
			this.podList = [
			{
			          label: this.$t('m.t.Basicport'),
			          options: [
											   		   {
											               value:  this.queryFclPodhistorys[0].split("/")[1],
											               label:  this.queryFclPodhistorys[0].split("/")[0],
											   			zhlabel:  this.queryFclPodhistorys[0].split("/")[2]
											             }, {
											              value: this.queryFclPodhistorys[1].split("/")[1],
											               label:  this.queryFclPodhistorys[1].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[1].split("/")[2]
											             },{
											              value: this.queryFclPodhistorys[2].split("/")[1],
											               label:   this.queryFclPodhistorys[2].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[2].split("/")[2]
											             },{
											             value:  this.queryFclPodhistorys[3].split("/")[1],
											              label:   this.queryFclPodhistorys[3].split("/")[0],
											             zhlabel:  this.queryFclPodhistorys[3].split("/")[2]
											             },{
											              value:  this.queryFclPodhistorys[4].split("/")[1],
											               label:   this.queryFclPodhistorys[4].split("/")[0],
											              zhlabel:  this.queryFclPodhistorys[4].split("/")[2]
											             }
										   
										   ]
			        }	
			]
		}
	}else{
		if(this.podquery==''){
		this.podList = [
		{
		          label: this.$t('m.t.Basicport'),
		          options: [
										   		   {
										              value: 'IDBTM',
										              label: 'BATAM',
										              zhlabel:'巴淡'
										             }
									   ]
		        }	
		];
	}
	}
	
	
	

},











	  //*******海运拼箱*******
	  async getLclPolList(){
	  	const query = this.lclpolquery
		if (query !== '') {
	  	const {data:res} = await this.$http.getManyTimesPortBySeaSelect({params:{query}})
	  	if (res.status !==0){
	  	 return this.$message.error('获取下拉列表数据失败!')
	  	}
	  	this.polLcllist = res.data.map(item => {
	  	  return { id: `${item.id}`, pol: `${item.portname}`,polcode:`${item.portcode}`,polzhname:`${item.portzhname}` };
	  	});
	  	this.polLclList = this.polLcllist.slice(0,10);
		}
	  },
async lclPolFilterMethod(query){
		this.lclpolquery = query
		  if (query !== '') {
			   this.loadinglclPolSelect = true;
			clearTimeout(this.timer)
			        this.timer = setTimeout(()=>{
						this.loadinglclPolSelect = false;
			        		this.getLclPolList()
			        	},200)     
		  } else {
		    this.polLclList = [
			{
			          label: this.$t('m.t.Hotports'),
			         options: [{
			           value: 'CNSHA',
			           label: 'SHANGHAI',
					   zhlabel:'上海'
			         }]
			        }	
			];
		  }  
	},
	 async getLclPodList(){
	 	const query = this.lclpodquery
		if (query !== '') {
	 	const {data:res} = await this.$http.getManyTimesPortBySeaSelect({params:{query}})
	 	if (res.status !==0){
	 	 return this.$message.error('获取下拉列表数据失败!')
	 	}
	 //	console.log(res.data)
	 	this.podLcllist = res.data.map(item => {
	 	  return { id: `${item.id}`, pod: `${item.portname}`,podcode:`${item.portcode}`,podzhname:`${item.portzhname}` };
	 	});
	 	this.podLclList = this.podLcllist.slice(0,10);
		}
	 }, 
	async lclPodFilterMethod(query){
	this.lclpodquery = query
	  if (query !== '') {
		   this.loadinglclPodSelect = true;
		clearTimeout(this.timer)
		        this.timer = setTimeout(()=>{
					this.loadinglclPodSelect = false;
		        		this.getLclPodList()
		        	},200)     
	  } else {
		  
		  setTimeout(() => {
			  if(this.tokenStr){
				  this.podLclList = [
				  {
				            label: this.$t('m.t.Basicport'),
				            options: [
				  								   		   {
				  								               value:  this.queryLclPodhistorys[0].split("/")[1],
				  								               label:  this.queryLclPodhistorys[0].split("/")[0],
				  								   			zhlabel:  this.queryLclPodhistorys[0].split("/")[2]
				  								             }, {
				  								              value: this.queryLclPodhistorys[1].split("/")[1],
				  								               label:  this.queryLclPodhistorys[1].split("/")[0],
				  								              zhlabel:  this.queryLclPodhistorys[1].split("/")[2]
				  								             },{
				  								              value: this.queryLclPodhistorys[2].split("/")[1],
				  								               label:   this.queryLclPodhistorys[2].split("/")[0],
				  								              zhlabel:  this.queryLclPodhistorys[2].split("/")[2]
				  								             },{
				  								             value:  this.queryLclPodhistorys[3].split("/")[1],
				  								              label:   this.queryLclPodhistorys[3].split("/")[0],
				  								             zhlabel:  this.queryLclPodhistorys[3].split("/")[2]
				  								             },{
				  								              value:  this.queryLclPodhistorys[4].split("/")[1],
				  								               label:   this.queryLclPodhistorys[4].split("/")[0],
				  								              zhlabel:  this.queryLclPodhistorys[4].split("/")[2]
				  								             }
				  							   
				  							   ]
				          }	
				  ];
			  }else{
				  this.podLclList = [
				  {
				            label: this.$t('m.t.Basicport'),
				            options: [
				  								   		   {
				  								              value: 'JPUKB',
				  								              label: 'KOBE',
				  								              zhlabel:'神户'
				  								             }
				  							   ]
				          }	
				  ];
			  }
			 
		  }, 200);  
	
		
		
		
		
		
	  } 	
	},  
	 focuslclpod(){
		 if(this.tokenStr){
			 if(this.lclpodquery==''){
			 this.podLclList = [
			 {
			           label: this.$t('m.t.Basicport'),
			           options: [
			 								   		   {
			 								               value:  this.queryLclPodhistorys[0].split("/")[1],
			 								               label:  this.queryLclPodhistorys[0].split("/")[0],
			 								   			zhlabel:  this.queryLclPodhistorys[0].split("/")[2]
			 								             }, {
			 								              value: this.queryLclPodhistorys[1].split("/")[1],
			 								               label:  this.queryLclPodhistorys[1].split("/")[0],
			 								              zhlabel:  this.queryLclPodhistorys[1].split("/")[2]
			 								             },{
			 								              value: this.queryLclPodhistorys[2].split("/")[1],
			 								               label:   this.queryLclPodhistorys[2].split("/")[0],
			 								              zhlabel:  this.queryLclPodhistorys[2].split("/")[2]
			 								             },{
			 								             value:  this.queryLclPodhistorys[3].split("/")[1],
			 								              label:   this.queryLclPodhistorys[3].split("/")[0],
			 								             zhlabel:  this.queryLclPodhistorys[3].split("/")[2]
			 								             },{
			 								              value:  this.queryLclPodhistorys[4].split("/")[1],
			 								               label:   this.queryLclPodhistorys[4].split("/")[0],
			 								              zhlabel:  this.queryLclPodhistorys[4].split("/")[2]
			 								             }
			 							   
			 							   ]
			         }	
			 ];	 
			  }
		 }else{
			 if(this.lclpodquery==''){
				this.podLclList = [
				{
				          label: this.$t('m.t.Basicport'),
				          options: [
												   		   {
												              value: 'JPUKB',
												              label: 'KOBE',
												              zhlabel:'神户'
												             }
											   ]
				        }	
				]; 
			 }
		 }
		 
		
		
		 
	 }, 
	//******空运**********  
	  
	 async getairPolList(){
	 	  	const query = this.airpolquery
			if (query !== '') {
	 	  	const {data:res} = await this.$http.getManyTimesAirPortSelect({params:{query}})
	 	  	if (res.status !==0){
	 	  	 return this.$message.error('获取下拉列表数据失败!')
	 	  	}
	 	  	console.log(res.data)
	 	  	this.polAirlist = res.data.map(item => {
	 	  	  return { id: `${item.id}`, pol: `${item.portname}`,polcode:`${item.portcode}`,polzhname:`${item.portzhname}` };
	 	  	});
	 	  	this.polAirList = this.polAirlist.slice(0,10);
			}
	 	  },
	 async airPolFilterMethod(query){
	 		this.airpolquery = query
	 		  if (query !== '') {
	 			   this.loadingairPolSelect = true;
	 			clearTimeout(this.timer)
	 			        this.timer = setTimeout(()=>{
	 						this.loadingairPolSelect = false;
	 			        		this.getairPolList()
	 			        	},200)     
	 		  } else {
	 		    this.polAirList = [
	 			{
	 			          label: this.$t('m.t.Hotports'),
	 			         options: [{
	 			           value: 'PVG',
	 			           label: 'SHANGHAI',
	 					   zhlabel:'上海'
	 			         }]
	 			        }	
	 			];
	 		  }  
	 	},
	 	 async getairPodList(){
	 	 	const query = this.airpodquery
			if (query !== '') {
	 	 	const {data:res} = await this.$http.getManyTimesAirPortSelect({params:{query}})
	 	 	if (res.status !==0){
	 	 	 return this.$message.error('获取下拉列表数据失败!')
	 	 	}
	 	 	//console.log(res.data)
	 	 	this.podAirlist = res.data.map(item => {
	 	 	  return { id: `${item.id}`, pod: `${item.portname}`,podcode:`${item.portcode}`,podzhname:`${item.portzhname}` };
	 	 	});
	 	 	this.podAirList = this.podAirlist.slice(0,10);
			}
	 	 }, 
	 	async airPodFilterMethod(query){
	 	this.airpodquery = query
	 	  if (query !== '') {
	 		   this.loadingairPodSelect = true;
	 		clearTimeout(this.timer)
	 		        this.timer = setTimeout(()=>{
	 					this.loadingairPodSelect = false;
	 		        		this.getairPodList()
	 		        	},200)     
	 	  } else {
			  setTimeout(() => { 
				 if(this.tokenStr){
				 				  this.podAirList = [
				 				  {
				 				            label: this.$t('m.t.Basicport'),
				 				            options: [
				 				  								   		   {
				 				  								               value:  this.queryAirPodhistorys[0].split(";")[1],
				 				  								               label:  this.queryAirPodhistorys[0].split(";")[0],
				 				  								   			zhlabel:  this.queryAirPodhistorys[0].split(";")[2]
				 				  								             }, {
				 				  								              value: this.queryAirPodhistorys[1].split(";")[1],
				 				  								               label:  this.queryAirPodhistorys[1].split(";")[0],
				 				  								              zhlabel:  this.queryAirPodhistorys[1].split(";")[2]
				 				  								             },{
				 				  								              value: this.queryAirPodhistorys[2].split(";")[1],
				 				  								               label:   this.queryAirPodhistorys[2].split(";")[0],
				 				  								              zhlabel:  this.queryAirPodhistorys[2].split(";")[2]
				 				  								             },{
				 				  								             value:  this.queryAirPodhistorys[3].split(";")[1],
				 				  								              label:   this.queryAirPodhistorys[3].split(";")[0],
				 				  								             zhlabel:  this.queryAirPodhistorys[3].split(";")[2]
				 				  								             },{
				 				  								              value:  this.queryAirPodhistorys[4].split(";")[1],
				 				  								               label:   this.queryAirPodhistorys[4].split(";")[0],
				 				  								              zhlabel:  this.queryAirPodhistorys[4].split(";")[2]
				 				  								             }
				 				  							   
				 				  							   ]
				 				          }			
				 				  ];
				 }else{
				 				  this.podAirList = [
				 				  {
				 				            label: this.$t('m.t.Basicport'),
				 				            options: [
				 				  								   		   {
				 				  								               value:'CHI/ORD',
				 				  								               label:'CHICAGO',
				 				  								   			zhlabel:'芝加哥'
				 				  								             }
				 				  							   
				 				  							   ]
				 				          }			
				 				  ];
				 } 
			  }, 200);  
			
	 	    
	 	  } 	
	 	},   
	  focusairpod(){
		  if(this.tokenStr){
			  if(this.airpodquery == ''){
			  			this.podAirList = [
			  			{
			  			          label:this.$t('m.t.Basicport'),
			  			          options: [
			  											   		   {
			  											               value:  this.queryAirPodhistorys[0].split(";")[1],
			  											               label:  this.queryAirPodhistorys[0].split(";")[0],
			  											   			zhlabel:  this.queryAirPodhistorys[0].split(";")[2]
			  											             }, {
			  											              value: this.queryAirPodhistorys[1].split(";")[1],
			  											               label:  this.queryAirPodhistorys[1].split(";")[0],
			  											              zhlabel:  this.queryAirPodhistorys[1].split(";")[2]
			  											             },{
			  											              value: this.queryAirPodhistorys[2].split(";")[1],
			  											               label:   this.queryAirPodhistorys[2].split(";")[0],
			  											              zhlabel:  this.queryAirPodhistorys[2].split(";")[2]
			  											             },{
			  											             value:  this.queryAirPodhistorys[3].split(";")[1],
			  											              label:   this.queryAirPodhistorys[3].split(";")[0],
			  											             zhlabel:  this.queryAirPodhistorys[3].split(";")[2]
			  											             },{
			  											              value:  this.queryAirPodhistorys[4].split(";")[1],
			  											               label:   this.queryAirPodhistorys[4].split(";")[0],
			  											              zhlabel:  this.queryAirPodhistorys[4].split(";")[2]
			  											             }
			  										   
			  										   ]
			  			        }			
			  			];  
			  }
		  }else{
			  if(this.airpodquery == ''){
				  this.podAirList = [
				  {
				            label: this.$t('m.t.Basicport'),
				            options: [
				  								   		   {
				  								               value:'CHI/ORD',
				  								               label:'CHICAGO',
				  								   			zhlabel:'芝加哥'
				  								             }
				  							   
				  							   ]
				          }			
				  ];
			  }
		  }
		
		  
	  },
	  
	  
	  
	  
	  
	  
	  //内陆拖车
	  async getTrailerList(){
	  	const {data:res} = await this.$http.getTrailerSelect()
	  	if (res.status !==0){
	  	 return this.$message.error('获取下拉列表数据失败!')
	  	}
	  	this.docklist = res.dock
	  	this.trailer_door_pointlist = res.trailer_door_point
	  },
		
	//起运港搜索自定义方法
	dockFilterMethod(query){
		this.dockquery = query
		console.log(this.dockquery)
		  if (query !== '') {
		    this.loadingdockSelect = true;
		    setTimeout(() => {
		      this.loadingdockSelect = false;
		      this.dockList = this.docklist.filter(item => {
		        return  `${item.dock}`.toLowerCase().indexOf(query.toLowerCase()) > -1;
		      }).slice(0,10);
		    }, 200);
		  } else {
			   setTimeout(() => {
		    this.dockList = [
			{
			          label: this.$t('m.t.Popularportarea'),
			         options: [{
			           value: '上海',
			           label: '上海',
					   zhlabel:'上海'
			         }]
			        }		
			];}, 200)
		  }
	},	
		
	//目的港搜索自定义方法
	trailer_door_pointFilterMethod(query){
		this.trailer_door_pointquery = query
		if (query !== '') {
		  this.loadingtrailer_door_pointSelect = true;
		  setTimeout(() => {
		    this.loadingtrailer_door_pointSelect = false;
		    this.trailer_door_pointList = this.trailer_door_pointlist.filter(item => {
		      return `${item.trailer_door_point}`.toLowerCase()
		        .indexOf(query.toLowerCase()) > -1;
		    }).slice(0,10);
		  }, 200);
		} else {
			setTimeout(() => {
				 if(this.tokenStr){
					 this.trailer_door_pointList = [
					 			 {
					 			           label: this.$t('m.t.mddz'),
					 			           options: [
					 						   		   {
					 						               value:  this.querytrailerPodhistorys[0].split("/")[1],
					 						               label:  this.querytrailerPodhistorys[0].split("/")[0],
					 						   			zhlabel:  this.querytrailerPodhistorys[0].split("/")[2]
					 						             }, {
					 						              value: this.querytrailerPodhistorys[1].split("/")[1],
					 						               label:  this.querytrailerPodhistorys[1].split("/")[0],
					 						              zhlabel:  this.querytrailerPodhistorys[1].split("/")[2]
					 						             },{
					 						              value: this.querytrailerPodhistorys[2].split("/")[1],
					 						               label:   this.querytrailerPodhistorys[2].split("/")[0],
					 						              zhlabel:  this.querytrailerPodhistorys[2].split("/")[2]
					 						             },{
					 						             value:  this.querytrailerPodhistorys[3].split("/")[1],
					 						              label:   this.querytrailerPodhistorys[3].split("/")[0],
					 						             zhlabel:  this.querytrailerPodhistorys[3].split("/")[2]
					 						             },{
					 						              value:  this.querytrailerPodhistorys[4].split("/")[1],
					 						               label:   this.querytrailerPodhistorys[4].split("/")[0],
					 						              zhlabel:  this.querytrailerPodhistorys[4].split("/")[2]
					 						             }
					 					   
					 					   ]
					 			         }	
					 ]; 
				 }else{
					this.trailer_door_pointList = [
								 {
								           label: this.$t('m.t.mddz'),
								           options: [
											   		   {
											               value:  `上海浦东`,
											               label:   `上海浦东`,
											   			zhlabel:   `上海浦东`
											             }
										   
										   ]
								         }	
					];  
				 }
		 
		  }, 200);
		}
	},	
	focusTrailerpod(){
		if(this.tokenStr){
			if(this.trailer_door_pointquery == ''){
			this.trailer_door_pointList = [
						 {
						           label: this.$t('m.t.mddz'),
						           options: [
									   		   {
									               value:  this.querytrailerPodhistorys[0].split("/")[1],
									               label:  this.querytrailerPodhistorys[0].split("/")[0],
									   			zhlabel:  this.querytrailerPodhistorys[0].split("/")[2]
									             }, {
									              value: this.querytrailerPodhistorys[1].split("/")[1],
									               label:  this.querytrailerPodhistorys[1].split("/")[0],
									              zhlabel:  this.querytrailerPodhistorys[1].split("/")[2]
									             },{
									              value: this.querytrailerPodhistorys[2].split("/")[1],
									               label:   this.querytrailerPodhistorys[2].split("/")[0],
									              zhlabel:  this.querytrailerPodhistorys[2].split("/")[2]
									             },{
									             value:  this.querytrailerPodhistorys[3].split("/")[1],
									              label:   this.querytrailerPodhistorys[3].split("/")[0],
									             zhlabel:  this.querytrailerPodhistorys[3].split("/")[2]
									             },{
									              value:  this.querytrailerPodhistorys[4].split("/")[1],
									               label:   this.querytrailerPodhistorys[4].split("/")[0],
									              zhlabel:  this.querytrailerPodhistorys[4].split("/")[2]
									             }
								   
								   ]
						         }	
			]	
			}
		}else{
			if(this.trailer_door_pointquery == ''){
				this.trailer_door_pointList = [
							 {
							           label: this.$t('m.t.mddz'),
							           options: [
										   		   {
										               value:  `上海浦东`,
										               label:   `上海浦东`,
										   			zhlabel:   `上海浦东`
										             }
									   
									   ]
							         }	
				];  
			}
		}
		
		
	},	
		
	
	//铁路
	  async getRailroadList(){
	  	const {data:res} = await this.$http.getRailroadSelect()
	  	if (res.status !==0){
	  	 return this.$message.error('获取下拉列表数据失败!')
	  	}
	  	this.railroadpollist = res.pol
	  	this.railroadpodlist = res.pod
	  },
		
	//起运港搜索自定义方法
	railroadpolFilterMethod(query){
		this.railroadpolquery = query
		  if (query !== '') {
		    this.loadingrailroadpolSelect = true;
		    setTimeout(() => {
		      this.loadingrailroadpolSelect = false;
		      this.railroadpolList = this.railroadpollist.filter(item => {
		        return  `${item.pol}`.toLowerCase().indexOf(query.toLowerCase()) > -1;
		      }).slice(0,10);
		    }, 200);
		  } else {
			   setTimeout(() => {
		    this.railroadpolList = [
			{
			          label: this.$t('m.t.Hotports'),
			         options: [{
			           value: 'Suzhou苏州',
			           label: 'Suzhou苏州',
					   zhlabel:'Suzhou苏州'
			         },
					 {
					   value: 'Jinhua金华',
					   label: 'Jinhua金华',
					   zhlabel:'Jinhua金华'
					 },
					 {
					   value: `Xi'an西安`,
					   label: `Xi'an西安`,
					   zhlabel:`Xi'an西安`
					 },
					 {
					   value: 'Chengdu成都',
					   label: 'Chengdu成都',
					   zhlabel:'Chengdu成都'
					 },
					 {
					   value: 'Zhengzhou郑州',
					   label: 'Zhengzhou郑州',
					   zhlabel:'Zhengzhou郑州'
					 }
					 ]
			        }		
			];}, 200)
		  }
	},	
		
	//目的港搜索自定义方法
	railroadpodFilterMethod(query){
		this.railroadpodquery = query
		if (query !== '') {
		  this.loadingrailroadpodSelect = true;
		  setTimeout(() => {
		    this.loadingrailroadpodSelect = false;
		    this.railroadpodList = this.railroadpodlist.filter(item => {
		      return `${item.pod}`.toLowerCase()
		        .indexOf(query.toLowerCase()) > -1;
		    }).slice(0,10);
		  }, 200);
		} else {
			setTimeout(() => {
				 if(this.tokenStr){
					 this.railroadpodList = [
					 			 {
					 			           label: this.$t('m.t.Basicport'),
					 			           options: [
					 						   		   {
					 						               value:  this.queryrailroadPodhistorys[0].split("/")[1],
					 						               label:  this.queryrailroadPodhistorys[0].split("/")[0],
					 						   			zhlabel:  this.queryrailroadPodhistorys[0].split("/")[2]
					 						             }, {
					 						              value: this.queryrailroadPodhistorys[1].split("/")[1],
					 						               label:  this.queryrailroadPodhistorys[1].split("/")[0],
					 						              zhlabel:  this.queryrailroadPodhistorys[1].split("/")[2]
					 						             },{
					 						              value: this.queryrailroadPodhistorys[2].split("/")[1],
					 						               label:   this.queryrailroadPodhistorys[2].split("/")[0],
					 						              zhlabel:  this.queryrailroadPodhistorys[2].split("/")[2]
					 						             },{
					 						             value:  this.queryrailroadPodhistorys[3].split("/")[1],
					 						              label:   this.queryrailroadPodhistorys[3].split("/")[0],
					 						             zhlabel:  this.queryrailroadPodhistorys[3].split("/")[2]
					 						             },{
					 						              value:  this.queryrailroadPodhistorys[4].split("/")[1],
					 						               label:   this.queryrailroadPodhistorys[4].split("/")[0],
					 						              zhlabel:  this.queryrailroadPodhistorys[4].split("/")[2]
					 						             }
					 					   
					 					   ]
					 			         }	
					 ]; 
				 }else{
					 this.railroadpodList = [
					 			 {
					 			           label: this.$t('m.t.Basicport'),
					 			           options: [
					 						   		   {
					 						               value:`Mala马拉`,
					 						               label:`Mala马拉`,
					 						   			zhlabel:`Mala马拉`
					 						             }
					 					   
					 					   ]
					 			         }	
					 ]; 
				 }
		 
		  }, 200);
		}
	},	
	focusrailroadpod(){
		if(this.tokenStr){
			if(this.railroadpodquery == ''){
			this.railroadpodList = [
						 {
						           label: this.$t('m.t.Basicport'),
						           options: [
									   		   {
									               value:  this.queryrailroadPodhistorys[0].split("/")[1],
									               label:  this.queryrailroadPodhistorys[0].split("/")[0],
									   			zhlabel:  this.queryrailroadPodhistorys[0].split("/")[2]
									             }, {
									              value: this.queryrailroadPodhistorys[1].split("/")[1],
									               label:  this.queryrailroadPodhistorys[1].split("/")[0],
									              zhlabel:  this.queryrailroadPodhistorys[1].split("/")[2]
									             },{
									              value: this.queryrailroadPodhistorys[2].split("/")[1],
									               label:   this.queryrailroadPodhistorys[2].split("/")[0],
									              zhlabel:  this.queryrailroadPodhistorys[2].split("/")[2]
									             },{
									             value:  this.queryrailroadPodhistorys[3].split("/")[1],
									              label:   this.queryrailroadPodhistorys[3].split("/")[0],
									             zhlabel:  this.queryrailroadPodhistorys[3].split("/")[2]
									             },{
									              value:  this.queryrailroadPodhistorys[4].split("/")[1],
									               label:   this.queryrailroadPodhistorys[4].split("/")[0],
									              zhlabel:  this.queryrailroadPodhistorys[4].split("/")[2]
									             }
								   
								   ]
						         }	
			]	
			}
		}else{
			if(this.railroadpodquery == ''){
				this.railroadpodList = [
							 {
							           label: this.$t('m.t.Basicport'),
							           options: [
										   		   {
										               value:`Mala马拉`,
										               label:`Mala马拉`,
										   			zhlabel:`Mala马拉`
										             }
									   
									   ]
							         }	
				]; 
			}
		}
		
		
	},	
	
	
  //****国际快递******
	  async getExpressPodList(){
		const query = this.expresspodquery
		if(query){
		const {data:res} = await this.$http.getManyTimesExpressCountrySelect({params:{query}})
		if (res.status !==0){
		 return this.$message.error('获取下拉列表数据失败!')
		}
		
		this.destinationlist = res.data.map(item => {
		  return { id: `${item.id}`, country_code: `${item.country_code}`,country_zh:`${item.country_zh}`,country_en:`${item.country_en}`  };
		});
		this.destinationList = this.destinationlist.slice(0,10)	
		}
	 
		
	  },  
async expresspodFilterMethod(query){
	this.expresspodquery = query
	  if (query !== '') {
		   this.loadingexpressPodSelect = true;
		clearTimeout(this.timer)
		        this.timer = setTimeout(()=>{
					this.loadingexpressPodSelect = false;
		        		this.getExpressPodList()
		        	},200)     
	  } else {
	setTimeout(() => {
		 if(this.tokenStr){
			 this.destinationList = [
			 {
			           label:this.$t('m.express.country'),
			           options: [
			 								   		   {
			 								               value:  this.queryExpressPodhistorys[0].split("/")[1],
			 								               label:  this.queryExpressPodhistorys[0].split("/")[0],
			 								   			zhlabel:  this.queryExpressPodhistorys[0].split("/")[2]
			 								             }, {
			 								              value: this.queryExpressPodhistorys[1].split("/")[1],
			 								               label:  this.queryExpressPodhistorys[1].split("/")[0],
			 								              zhlabel:  this.queryExpressPodhistorys[1].split("/")[2]
			 								             },{
			 								              value: this.queryExpressPodhistorys[2].split("/")[1],
			 								               label:   this.queryExpressPodhistorys[2].split("/")[0],
			 								              zhlabel:  this.queryExpressPodhistorys[2].split("/")[2]
			 								             },{
			 								             value:  this.queryExpressPodhistorys[3].split("/")[1],
			 								              label:   this.queryExpressPodhistorys[3].split("/")[0],
			 								             zhlabel:  this.queryExpressPodhistorys[3].split("/")[2]
			 								             },{
			 								              value:  this.queryExpressPodhistorys[4].split("/")[1],
			 								               label:   this.queryExpressPodhistorys[4].split("/")[0],
			 								              zhlabel:  this.queryExpressPodhistorys[4].split("/")[2]
			 								             }
			 							   
			 							   ]
			         }	
			 ]
		 }else{
			this.destinationList = [
			{
			          label:this.$t('m.express.country'),
			          options: [
											   		   {
											               value: 'USW',
											               label: 'united states(West)',
											   			zhlabel:'美国西部'
											             }
										   
										   ]
			        }	
			] 
		 }
			
			}, 200);  
		  
	  
	  } 
	
	
},  
focusexpresspod(){
		 if(this.tokenStr){
			 if(this.expresspodquery==''){
			 	this.destinationList = [
			 	{
			 	          label:this.$t('m.express.country'),
			 	          options: [
			 									   		   {
			 									               value:  this.queryExpressPodhistorys[0].split("/")[1],
			 									               label:  this.queryExpressPodhistorys[0].split("/")[0],
			 									   			zhlabel:  this.queryExpressPodhistorys[0].split("/")[2]
			 									             }, {
			 									              value: this.queryExpressPodhistorys[1].split("/")[1],
			 									               label:  this.queryExpressPodhistorys[1].split("/")[0],
			 									              zhlabel:  this.queryExpressPodhistorys[1].split("/")[2]
			 									             },{
			 									              value: this.queryExpressPodhistorys[2].split("/")[1],
			 									               label:   this.queryExpressPodhistorys[2].split("/")[0],
			 									              zhlabel:  this.queryExpressPodhistorys[2].split("/")[2]
			 									             },{
			 									             value:  this.queryExpressPodhistorys[3].split("/")[1],
			 									              label:   this.queryExpressPodhistorys[3].split("/")[0],
			 									             zhlabel:  this.queryExpressPodhistorys[3].split("/")[2]
			 									             },{
			 									              value:  this.queryExpressPodhistorys[4].split("/")[1],
			 									               label:   this.queryExpressPodhistorys[4].split("/")[0],
			 									              zhlabel:  this.queryExpressPodhistorys[4].split("/")[2]
			 									             }
			 								   
			 								   ]
			 	        }	
			 	]
			 }
		 }else{
			  if(this.expresspodquery==''){
				  this.destinationList = [
				  {
				            label:this.$t('m.express.country'),
				            options: [
				  								   		   {
				  								               value: 'USW',
				  								               label: 'united states(West)',
				  								   			zhlabel:'美国西部'
				  								             }
				  							   
				  							   ]
				          }	
				  ]
			  }
		 }
	
	

},	
	
	
	
		
		
		
		
		
	  //海运整箱特价
		async getSpecialFclSaleList(){
			  const {data:res} = await this.$http.getSpecialFclSaleList()
			  if (res.status !==0){
			   return this.$message.error('获取数据失败!')
			  }
			   this.specialPriceFclList = res.data
		  },
		  //海运整箱		    
	  queryShow(){
		  if(this.queryInfo.pol === ''){
		  	 return this.$message.error(this.$t('m.queryRequired.polRequired'))
		  }
		  if(this.queryInfo.pod === ''){
		  	 return this.$message.error(this.$t('m.queryRequired.podRequired'))
		  }
		  //用name传参数可以刷新流失参数，用path则不会流失参数
      this.$router.push({name:'fclbysea',params: {pol:this.queryInfo.pol,pod:this.queryInfo.pod}})
	  },
	  //海运拼箱
	  queryLclShow(){
	  	if(this.queryInfo.lclpol === ''){
	  			  	 return this.$message.error(this.$t('m.queryRequired.polRequired'))
	  			  }
	  			  if(this.queryInfo.lclpod === ''){
	  			  	 return this.$message.error(this.$t('m.queryRequired.podRequired'))
	  			  }
	  			  //用name传参数可以刷新流失参数，用path则不会流失参数
	  	this.$router.push({name:'lclbysea',params: {lclpol:this.queryInfo.lclpol,lclpod:this.queryInfo.lclpod}})
	  },
	   //海运拼箱特价
	   async getSpecialLclSaleList(){
	   	  const {data:res} = await this.$http.getSpecialLclSaleList()
	   	  if (res.status !==0){
	   	   return this.$message.error('获取数据失败!')
	   	  }
	   	   this.specialPriceLclList = res.data
	     },
		 
	//内陆拖车
	queryTrailerShow(){
		if(this.queryInfo.dock === ''){
				  	 return this.$message.error(this.$t('m.queryRequired.dockRequired'))
				  }
				  if(this.queryInfo.trailer_door_point === ''){
				  	 return this.$message.error(this.$t('m.queryRequired.trailer_door_pointRequired'))
				  }
				  //用name传参数可以刷新流失参数，用path则不会流失参数
		this.$router.push({name:'trailer',params: {dock:this.queryInfo.dock,trailer_door_point:this.queryInfo.trailer_door_point}})
	},
	 // //内陆拖车特价
	 async getSpecialTrailerSaleList(){
	 	  const {data:res} = await this.$http.getSpecialTrailerSaleList()
	 	  if (res.status !==0){
	 	   return this.$message.error('获取数据失败!')
	 	  }
	 	   this.specialPriceTrailerList = res.data
	   },
	   
	   //铁路
	   queryRailRoad(){
	   	if(this.queryInfo.railroadpol === ''){
	   			  	 return this.$message.error(this.$t('m.queryRequired.polRequired'))
	   			  }
	   			  if(this.queryInfo.railroadpod === ''){
	   			  	 return this.$message.error(this.$t('m.queryRequired.podRequired'))
	   			  }
	   			  //用name传参数可以刷新流失参数，用path则不会流失参数
	   	this.$router.push({name:'railroad',params: {pol:this.queryInfo.railroadpol,pod:this.queryInfo.railroadpod}})
	   },
	    //铁路特价
	    async getSpecialRailRoadSaleList(){
	    	  const {data:res} = await this.$http.getSpecialRailRoadSaleList()
	    	  if (res.status !==0){
	    	   return this.$message.error('获取数据失败!')
	    	  }
	    	   this.specialPriceRailRoadList = res.data
	      },
	   
	   
	   
		//**************空运******************
		queryAirShow(){
		if(this.queryInfo.airpol === ''){
				  	 return this.$message.error(this.$t('m.queryRequired.polRequired'))
				  }
				  if(this.queryInfo.airpod === ''){
				  	  return this.$message.error(this.$t('m.queryRequired.podRequired'))
				  }
				  //用name传参数可以刷新流失参数，用path则不会流失参数
		this.$router.push({name:'byair',params: {airpol:this.queryInfo.airpol,airpod:this.queryInfo.airpod}})
	},
	//空运特价
	async getSpecialByAirSaleList(){
		  const {data:res} = await this.$http.getSpecialByAirSaleList()
		  if (res.status !==0){
		   return this.$message.error('获取数据失败!')
		  }
		   this.specialPriceAirList = res.data
	  },	 
		 
	//国际快递
		 queryShowExpress(){
			 if(this.queryInfo.expresspod === ''){
			 		  	 return this.$message.error(this.$t('m.express.qxzmdd'))
			 		  }
			 		  if(this.queryInfo.num ==undefined || this.queryInfo.num == 0){
			 		  	 return this.$message.error(this.$t('m.express.qxzweight'))
			 		  }
					  if(this.queryInfo.num > 299){
					  	 return this.$message.error(this.$t('m.express.weightLimit'))
					  }
			 		  //用name传参数可以刷新流失参数，用path则不会流失参数
			 this.$router.push({name:'express',params: {pod:this.queryInfo.expresspod,num:this.queryInfo.num}})
			 
		 },
	//国际快递特价
	async getSpecialExpressSaleList(){
		  const {data:res} = await this.$http.getSpecialExpressSaleList()
		  if (res.status !==0){
		   return this.$message.error('获取数据失败!')
		  }
		   this.specialPriceExpressList = res.data
	  },	 
	  handleClick(tab, event) {
	    //       console.log(tab, event);
			  // console.log(this.activeName)
			  //优化请求处理
			  if(this.activeName =='fcl'){
			  	 this.specialPriceLclList = []
				 this.specialPriceTrailerList = []
				 this.specialPriceAirList = []
				 this.specialPriceRailRoadList = []
				 this.specialPriceExpressList = []
			  	this.getSpecialFclSaleList()
			  }else if(this.activeName =='lcl'){
			 this.specialPriceFclList = []
			 this.specialPriceAirList = []
			 this.specialPriceTrailerList = []
			 this.specialPriceRailRoadList = []
			  this.specialPriceExpressList = []
			  this.getSpecialLclSaleList()
		}else if(this.activeName =='car'){
			  this.specialPriceFclList = []
			  this.specialPriceAirList = []
		      this.specialPriceLclList = []
			  this.specialPriceRailRoadList = []
			   this.specialPriceExpressList = []
			  this.getTrailerList()
			  this.getSpecialTrailerSaleList()
		}else if(this.activeName =='air'){
			  this.specialPriceFclList = []
		      this.specialPriceLclList = []
			  this.specialPriceTrailerList = []
			  this.specialPriceRailRoadList = []
			   this.specialPriceExpressList = []
			  this.getSpecialByAirSaleList()
		} else if(this.activeName =='railway'){
			this.specialPriceFclList = []
			this.specialPriceLclList = []
			this.specialPriceTrailerList = []
			this.specialPriceAirList = []
			 this.specialPriceExpressList = []
			  this.getSpecialRailRoadSaleList()
			  this.getRailroadList()
		} else{
			this.specialPriceFclList = []
			this.specialPriceLclList = []
			this.specialPriceTrailerList = []
			this.specialPriceAirList = []
			this.specialPriceRailRoadList = []
			this.getSpecialExpressSaleList()
		}  
				
	        },
			

//判断手机端我要订舱弹窗宽度
wydcmenthod(){
	let result = window.matchMedia('(max-width:1280px)')
	  if(result.matches){
		  this.dtwdith = '90%'
		  this.centerDialogVisibleWidth  = '100%'
		  this.labelposition = 'left'
		  this.labelwidth = '95px'
	  }else{
		  this.dtwdith = '30%'
		  this.centerDialogVisibleWidth  = '70%'
		  this.labelposition = 'right'
		  this.labelwidth = '160px'
	  }
	
},




			
			
//海运整箱特价卡片订舱
 fcltj(data){
	 if(!this.tokenStr){
	 		return this.$message({
	 										type:'warning',
	 										message:this.$t('m.t.pleaseLog'),
	 										offset:300,
	 										center:true,
	 										}
	 										)
	 				
	 }
	// console.log(data)
	 const dataInfo ={
	 	...data,
	 	nameModule:`海运整箱特惠航线`,
	 	
	 }
				this.dcData = dataInfo
				this.dcForm.transportation = '海运整箱'
				//console.log(this.dcData)
				this.wydcmenthod()
		     	this.dialogVisible = true
			},
			
	//海运拼箱特价卡片订舱		
			lcltj(data){
				if(!this.tokenStr){
						return this.$message({
														type:'warning',
														message:this.$t('m.t.pleaseLog'),
														offset:300,
														center:true,
														}
														)
								
				}
			const dataInfo ={
				...data,
				nameModule:`海运拼箱特惠航线`,
				
			}
							this.dcData= dataInfo
							this.dcForm.transportation = '海运拼箱'
							this.wydcmenthod()
					     	this.dialogVisible = true	
			},
			//空运特价卡片订舱
					airtj(data){
						if(!this.tokenStr){
								return this.$message({
																type:'warning',
																message:this.$t('m.t.pleaseLog'),
																offset:300,
																center:true,
																}
																)
										
						}
					const dataInfo ={
						...data,
						nameModule:`空运特惠航线`,
						
					}
									this.dcData= dataInfo
									this.dcForm.transportation = '空运'
									this.wydcmenthod()
							     	this.dialogVisible = true	
					},
					//内陆拖车特价卡片订舱
							trailertj(data){
								if(!this.tokenStr){
										return this.$message({
																		type:'warning',
																		message:this.$t('m.t.pleaseLog'),
																		offset:300,
																		center:true,
																		}
																		)
												
								}
							const dataInfo ={
								...data,
								nameModule:`内陆拖车特惠航线`,
								
							}
											this.dcData= dataInfo
											this.dcForm.transportation = '内陆拖车'
											this.wydcmenthod()
									     	this.dialogVisible = true	
							},
							//铁路特价卡片订舱
									Railroadtj(data){
										if(!this.tokenStr){
												return this.$message({
																				type:'warning',
																				message:this.$t('m.t.pleaseLog'),
																				offset:300,
																				center:true,
																				}
																				)
														
										}
									const dataInfo ={
										...data,
										nameModule:`铁路特惠航线`,
										
									}
													this.dcData= dataInfo
													this.dcForm.transportation = '铁路'
													this.wydcmenthod()
											     	this.dialogVisible = true	
									},
									//国际快递特价卡片订舱
											expresstj(data){
												if(!this.tokenStr){
														return this.$message({
																						type:'warning',
																						message:this.$t('m.t.pleaseLog'),
																						offset:300,
																						center:true,
																						}
																						)
																
												}
											const dataInfo ={
												...data,
												nameModule:`国际快递特惠航线`,
												
											}
															this.dcData= dataInfo
															this.dcForm.transportation = '国际快递'
															this.wydcmenthod()
													     	this.dialogVisible = true	
											},
			//请专属客服与我联系
			async zskflx(){
				
				const {data:res} = await this.$http.sendOrderTjkpToCustomerService({data:this.dcData})
				       // if (res.status !==0){
				       // 	return this.$message.error(this.$t('m.entrustment.selecttwoError'))
				       // }
					   
					   if (res.status ==2){
					   	return this.$message.warning(this.$t('m.tips.dsh1'))
					   }
					   if (res.status ==3){
					   	return this.$message.error(this.$t('m.tips.shbtg'))
					   }
										this.$message({
														type:'success',
														message:this.$t('m.entrustment.selecttwoSuccess'),
														offset:300,
														center:true,
														}
														)
														var el=document.querySelector('.el-message');
										if(el) el.style.cssText = ' background-color: #f0f9eb;border-color: #e1f3d8;height: 150px;border-radius: 15px;'
				this.dialogVisible = false
				
			},
			transportationChange(e){
				if(e === '海运拼箱' || e === '空运' || e === '国际快递'){
					this.dcForm.ershigp_num = 0
					this.dcForm.sishigp_num = 0
					this.dcForm.sishihq_num = 0
					this.dcForm.qtgg_num = ''
				}
			},
			//提交出运委托书
			confirmdc(){
				let dcDataAll = {
					...this.dcForm,
					...this.dcData,
					otherName:`出运委托书`
				}
				//console.log(dcDataAll)
			let fd = new FormData();
			//上传的图片
			 fd.append('attachment', this.file)
			 //数据参数
			 fd.append("dcDataAll", JSON.stringify(dcDataAll));
			// console.log(fd)
				this.$refs.dcFormRef.validate(async valid =>{
					if (valid){ //如果表单验证合格
					const {data:res} = await this.$http.sendOrderTjkpShipmentToCustomerService({data:fd})
					// if (res.status !==0){
					// 	return this.$message.error(this.$t('m.entrustment.entrustmentWrite.submissionfailed'))
					// }
					if (res.status ==2){
						return this.$message.warning(this.$t('m.tips.dsh1'))
					}
					if (res.status ==3){
						return this.$message.error(this.$t('m.tips.shbtg'))
					}
												
					this.$message({
					type:'success',
					message:this.$t('m.entrustment.entrustmentWrite.submissionsuccess'),
					offset:300,
					center:true,
					}
					)
					var el=document.querySelector('.el-message');
					if(el) el.style.cssText = ' background-color: #f0f9eb;border-color: #e1f3d8;height: 150px;border-radius: 15px;'
					this.centerDialogVisible = false
					this.dialogVisible = false
					}else{//表单验证不合格，阻止默认行为（因为按钮有默认提交行为）
					this.$message.error(this.$t('m.entrustment.entrustmentWrite.qxztransportationRequired'))
						return false
					}
				
				})
				
			},

			 
			 //上传文件之前的钩子
			    beforeUpload(file) {
			     //  console.log("文件", file);
			       this.file = file;
			       this.fileName = file.name;
				   console.log(this.file)
				   console.log(this.fileName )
			       this.fileSize = file.size;
				  // console.log(this.fileSize)
				   //限制文件大小
				    const isLt5M = file.size / 1024 / 1024 < 5;
					if(isLt5M){
						let reader = new FileReader();
						reader.readAsDataURL(file);
						let that = this;
						reader.onload = function() {
						  that.fileData = reader.result;
						  // console.log("fileData", reader.result);
						 // console.log("fileData", that.fileData);
						};
						return false; // 返回false不会自动上传
					}else{
						 this.$message.error(this.$t('m.entrustment.entrustmentWrite.limit'));
					}
			      
			     },
			 
			 
			 //预览文件
			    viewFile() {
			       //console.log("viewFile");
			       var win = window.open();
			       win.document.write(
			         '<body style="margin:0px;"><object data="' +
			           this.fileData +
			           '" type="application/pdf" width="100%" height="100%"><iframe src="' +
			           this.fileData +
			           '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></object></body>'
			       );
			     },
			 handleChange(file, fileList) {
			        this.fileList = fileList.slice(-3);
			      },
			 	 //删除时触发以下数据清空
			 	 handleRemove(file, fileList) {
			 	//console.log(this.fileData == '')
			 	//判断一下条件
			 			if(this.fileData){
			 				this.fileList = []
			 				this.fileData = ''
			 				this.file = ''
			 				this.fileName = ''
			 			}	      
			 	      },
			
			//监听关闭
			dcDialogClosed(){
				this.$refs.dcFormRef.resetFields()
				this.fileList = []
				this.file = ''
				this.fileData = ''
				this.fileName = ''
				this.dcForm.transportation = ''
				this.dcForm.ershigp_num = 0
				this.dcForm.sishigp_num = 0
				this.dcForm.sishihq_num = 0
				this.dcForm.qtgg_num = ''
				this.cywtsactiveName = 'txwts'
			},			
			
			
			
		
  }
};
</script>

<style lang="scss" scoped>
	// 使用在线iconfont图标资源
@import url(//at.alicdn.com/t/c/font_4358597_05gnp759hcj8.css);

 @media screen and (min-width: 1280px) {
	 
	  .home{
	 width: 100%;
	 height: 100vh;
	 //缩小高度min-height
	 min-height: 800px;
	 background-size: cover;
	 background-position: center;
	 background: url(../../assets/img/login-img.jpg);   
	 background-size: 100% 100%;
	  }
	// 重点样式
	.ysbj{
		top:50%;
		left: 50%;
		position: relative;
		width: 1525px;
		min-width: 1525px;
		min-height: 800px;
		height: 800px;
		transform: translate(-50%,-50%); 
	}
	
	.wrapper{
		 padding-top: 140px;
		 padding-left: 150px;
		 padding-right: 150px;
		position: relative;
	}
	.card-box{
		 padding-top: 189px;
		 padding-left: 150px;
		 padding-right: 150px;
		width: 100%;
		position: absolute;
	.box-card{
		width: 100%;
		height: 110px;
		border-radius: 0 0 10px 10px;
	}
	 }
	 .fclstylepc,.lclstylepc,.airstylepc,.railwaystylepc,.carstylepc,.expressstylepc{
		 display: flex;
	 }
	 .fclstylephone,.lclstylephone,.airstylephone,.railwaystylephone,.carstylephone,.expressstylephone{
		 display: none;
	 }
	 .fcltjcardstylephone,.lcltjcardstylephone,.airtjcardstylephone,.railwaytjcardstylephone,.cartjcardstylephone,.expresstjcardstylephone{
	 		 display: none;
	 }
	 .box-query{
	 display: flex;
	 padding: 15px;
	 margin-left: 20px;
	 margin-top: 7px;
	 border: 1px solid #E5E5E5; 
	 width: 700px;
	 height: 70px;
	 border-radius: 7px;
	 }
	 .box-query1{
	 display: flex;
	 padding: 15px;
	 margin-left: 10px;
	 margin-top: 5px;
	 border: 1px solid #E5E5E5; 
	 width: 350px;
	 height: 70px;
	 border-radius: 7px;	
	 }

	 .boxtjcard{
	 	width: 100%;
	  	border-radius:10px;
	 	height: 435px;
	  }
	  .box-card-list{
	  		width: 384px;
	  		height: 140px;
	  		box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.15) !important;
	  		
	  	}
		.wydcStyle{
			display: flex;
			justify-content: space-around;
		}
	  	.wydcStylebtn{
			width:200px
		}
		.entrustmentphone{
	display: none;
}  
 }
 //手机端
 @media screen and (max-width: 1280px) {

	 .home{
	 width: 100%;
	 height: 100%;
	 background-size: cover;
	 background-position: center;
	 background: url(../../assets/img/login-img.jpg);   
	 background-size: 100% 100%;
	 padding-bottom: 20px;
	  }
 // 重点样式
 .ysbj{
 	left: 50%;
 	position: relative;
 	transform: translate(-50%); 
 }
 
 .wrapper{
 	 padding-top: 140px;
 	 padding-left: 5px;
 	 padding-right: 5px;
 	position: relative;
 }
 .card-box{
 	 padding-top: 189px;
 	 padding-left: 5px;
 	 padding-right: 5px;
 	width: 100%;
 	position: absolute;
 .box-card{
 	width: 100%;
 	height: 260px;
 	border-radius: 0 0 10px 10px;
 }
  }
.fclstylepc,.lclstylepc,.airstylepc,.railwaystylepc,.carstylepc,.expressstylepc{
	display: none;
}
 //特价卡片
 .fcltjcardstyle,.lcltjcardstyle,.airtjcardstyle,.railwaytjcardstyle,.cartjcardstyle,.expresstjcardstyle{
	 display: none;
 }
.box-query{
display: flex;
flex-direction: column;
padding: 15px;
margin-left: 20px;
margin-top: 7px;
border: 1px solid #E5E5E5; 
width: 90%;
height: 70px;
border-radius: 7px;
}
.box-query1{
display: flex;
flex-direction: column;
padding: 15px;
margin-left: 20px;
margin-top: 7px;
border: 1px solid #E5E5E5; 
width: 90%;
height: 70px;
border-radius: 7px;	
}	 
.boxtjcard{
	width: 100%;
 	border-radius:10px;
	height: 100%;
 }	
 .box-card-list{
 		width: 100%;
 		height: 140px;
 		box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.15) !important;
 		
 	}
.wydcStyle{
			text-align: center;	
		}
.wydcStylebtn{
	margin:5px
}	
.entrustmentpc{
	display: none;
}  	
		 
 }
 
 
 
 
 
 //********************************************
 //特惠价格样式
 .tjcard{
	 width: 100%;
	margin-top: 40px;
 }		 
 ::v-deep .tabsCard .el-tabs__item {
   color: #FFFFFF;
   border-top-left-radius: 10px;
   border-top-right-radius: 10px;
   height: 50px;
   line-height: 50px;
   width: 150px;
   text-align: center;
 }

//  //去除边框
::v-deep .tabsCard.el-tabs--card>.el-tabs__header .el-tabs__nav{
 			border: none;
			
 		}
 ::v-deep .tabsCard.el-tabs--card>.el-tabs__header .el-tabs__item{
  			border: none;
  		}
 ::v-deep .tabsCard .el-tabs__item:hover{
  color: #000000;
}
 ::v-deep .tabsCard .el-tabs__item.is-active{
    color: #000000;
    background-color: #FFFFFF;
}
//下拉框

.el-select ::v-deep .el-input__inner {
    border: none;
	width: 300px;
}
::v-deep .el-icon-arrow-up:before {
    content: none;
}

.wz{
	margin-top: -23px;
	z-index: 200;
}
.wz1 {
		margin-top: -23px;
		position: absolute;
		z-index: 200;
	}
.wz2{
	margin-top: -23px;
	position: absolute;
	margin-left: 320px;
	z-index: 200;
}
.wz3{
	line-height: 75px;  // 控制元素垂直距离
	text-align: center;
	padding: 0 15px 0 0;
}

	
//下拉选项展开行高度
.el-select-dropdown__item{
		height: 54px;
		line-height: 54px;
	}
	
.railwayxgselect{
	.el-select-dropdown__item{
	           	height: 42px;
	           	line-height: 42px;
	  
	}
}
	
	
	
.ggg{
       cursor: pointer;
	   background-color: lightgray;
	 
	  
}	
::v-deep .el-dialog--center .el-dialog__body {
    text-align: center;
    padding: 25px 25px 30px;
}
	
::v-deep .inputnumberclass.el-input-number .el-input__inner {
	margin-top: 5px;
	height: 72px;
}
::v-deep .inputnumberclass .el-input-number__decrease {
	margin-top: 5px;
	line-height: 70px;
}
::v-deep .inputnumberclass .el-input-number__increase {
	margin-top: 5px;
	line-height: 70px;
}
	::v-deep .el-tabs__nav-prev,::v-deep .el-tabs__nav-next {
	    color: white;
	}
</style>
